(function (root, factory) {
  /*global module, define, define*/
  if (typeof exports === 'object') {
    // COMMON-JS
    module.exports = factory();
  } else if (typeof define === 'function' && define['amd']) {
    // Asynchronous Module Definition AMD
    define([], factory);
  } else {
    //GLOBAL (e.g. browser)
    root['TPP_API'] = factory();
  }
}(this, function () {
  'use strict';
  /* globals Promise */


  var FRONTEND_VERSION = "1.2.17";
  var GIT_HASH = "58e04854ee7e5216adab8fdb159570d4fa822e68";

  var messageReceiverOverride = null; // for debugging and tests

  var DEFAULT_CONFIG = {
    origin: "*",          // every origin allowed
    autoScanDelay: null,  // disabled,
    alwaysDebug: false,   // debug will be enabled by default, "false" means debug has to be toggled manually
    autoReload: false,     // disabled
    deleteSectionEnabled: false,
    deletePageWorkflow: null,
    workflowMode: 'PAGE_DRIVEN'
  };

  var config = {};

  var util = {};

  /**
   * @private
   * @param {HTMLElement} [$root] - The root to search from, document if not set.
   * @return {[]}
   */
  util.previewElements = function ($root) {
    return [].slice.call(($root || document).querySelectorAll('[data-preview-id]'));
  };

  util.filter = {};

  /*
   * Filter predicate
   */
  util.filter.byId = function (previewId) {
    return function ($el) {
      return $el.dataset.previewId === previewId;
    };
  };

  util.filter.byNonEmpty = function (result) {
    return (!!result);
  };


  /**
   * This generates a mapper that is initialized by a list of status elements.
   * The generated mapper matches a given element with a previewId against the list
   * of status elements.
   *  If there is no match it maps to null.
   *  If there is a match it maps to an info object like this:
   *  {
   *    target,    //The HTMLElement that was given.
   *    previewId, //The involved previewId as string
   *    status     //The status object of the store element
   *  }
   * @private
   * @param affected
   *  A WorkflowResult holding a "statusList"
   * @return {Function}
   *  A mapper from {HTMLElement}->{target,previewId,status}
   */
  util.filter.matchAffectedInfo = function (affected) {

    var statusMap = {};
    if (affected && affected['statusList']) {
      affected['statusList'].forEach(function (status) {
        statusMap[status['id']] = status;
      });
    }

    return function ($el) {
      var previewId = $el.dataset.previewId;
      var fsIdInfo = util.previewIdCache(previewId);
      if (fsIdInfo) {
        var id = fsIdInfo['id'].toString();
        var status = statusMap[id];
        if (status && status['storeType'] === fsIdInfo['store']) {
          return {
            previewId: previewId,
            status: status,
            $target: $el
          };
        }
      }
      return null;
    }
  };


  /**
   * Poor-developers isFunction. Not full lodash version.
   */
  util.isFunction = function (val) {
    return typeof (val) === 'function';
  };

  /**
   * Object means arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`
   * Compare with lodash.
   * @param val
   * @return {boolean} true, if val is an 'Object'
   */
  util.isObject = function (val) {
    var type = typeof val
    return val != null && (type == 'object' || type == 'function')
  };

  /**
   * Poor-developers isString. Not full lodash version.
   */
  util.isString = function (val) {
    return typeof (val) === 'string';
  };


  /**
   * Message Service doing all the communication with the
   * fs-tpp-receiver.js located in the ContentCreator parent window.
   *
   * Utilizes Window.postMessage.
   * The Service stores the callbacks, calls them when the matching response-message is received
   * and then remove the callback from storage.
   * @name TppMessageService
   * @private
   * @see {Window}
   * @type {{init, send, serialize, setInternalEventHandler, updateReceiver}}
   */
  // Serialize a callback to an id for postMessage usage
  util.messageService = (function () {


    var ms = {};

    /**
     * Message type of incoming messages from the fs-tpp-receiver in the outer frame.
     * @name TppMessageService.MessageType
     * @private
     */
    var MESSAGE_TYPE = {
      /**
       * @name TppMessageService.MessageType.CALLBACK
       */
      CALLBACK: "CALLBACK",
      /**
       * @name TppMessageService.MessageType.EVENT
       */
      EVENT: "EVENT"
    };

    /// ====== Callback storage ======
    var storage = [null];

    /**
     * Stores a callback under a given id.
     * @param {function} callback - The function to be stored.
     * @return {number} - The callback id.
     *        Might be null if no function is given.
     */
    ms.serialize = function (callback) {
      if (typeof (callback) === 'function') {
        return storage.push(callback) - 1;
      }
      return null;
    };

    /**
     * Invokes a callback for the given callbackId with data as first parameter
     * @param {number} callbackId - A callback id
     * @param {string|Object}data
     * @private
     */
    var deserialize = function (callbackId, data, permanent) {
      if (callbackId && storage[callbackId]) {
        storage[callbackId].call(null, data);
        if (!permanent) {
          delete storage[callbackId];
        }
      }
    };

    var tryParseResult = function (result) {
      if (typeof (result) === 'string' && result.match(/^\s*[\[{"]/) !== null) {
        try {
          return JSON.parse(result);
        } catch (ignore) {
          // not a json
        }
      }
      return result;
    };

    var handleCallback = function (tppMessage) {
      /** @type {string|Object} */
      var response = tppMessage._response;
      var callbackId = tppMessage._callbackId;
      deserialize(callbackId, tryParseResult(response));
    };


    // ======= Event Handler ====== //
    /**
     * List of possible event handlers. The handlers translates the internal _messageId
     * These are internal markers of events.
     */
    var EVENT_HANDLER = {};
    var handleOuterEvent = function (tppMessage) {
      var eventHandler = EVENT_HANDLER[tppMessage._eventId];
      if (typeof eventHandler === 'function') {
        var payload = tppMessage._payload;
        eventHandler(tryParseResult(payload));
      }
    };

    ms.setInternalEventHandler = function (name, eventHandler) {
      EVENT_HANDLER[name] = eventHandler;
    };

    /**
     * Handles incomming messages from the fs-tpp-receiver in the outer frame.
     * It dispatches the diferent types of messages.
     * @param e
     */
    var receiveMessage = function (e) {
      if (typeof (e.data) === 'object' && typeof (e.data.tpp) === 'object') {
        util.log("Message Received ", e.data);
        if (e.data.tpp._messageType === MESSAGE_TYPE.CALLBACK) {
          handleCallback(e.data.tpp);
        } else if (e.data.tpp._messageType === MESSAGE_TYPE.EVENT) {
          handleOuterEvent(e.data.tpp);
        }
      }
    };

    /**
     * Internal send message to the fs-tpp-receiver.
     * The messageReceiverOverride gives the opportunity to mock the outer frame during testing or write
     * your own connection glue code.
     * @param message
     * @param origin
     */
    var sendMessageInternal = function (message, origin) {
      if (messageReceiverOverride && typeof messageReceiverOverride.postMessage === 'function') {
        // Testing and mocking override
        messageReceiverOverride.postMessage(message, origin);
      } else if (typeof window !== 'undefined' && window['top'] !== window) {
        // Default case
        window.top.postMessage(message, origin);
      }
    };

    /**
     * Send a message to the fs-tpp-receiver running in the outer frame.
     * Expect to get a message back of {@link TppMessageService.MessageType.CALLBACK}
     * @private
     * @param {Object} message
     * @param {Function} [callback]
     * @param {string} origin
     */
    ms.send = function (message, origin, callback) {
      if (typeof callback === 'function') {
        message.tpp = message.tpp || {};
        message.tpp._callbackId = ms.serialize(callback);
      }
      sendMessageInternal(message, origin);
      util.log("Message send ", message, origin);
    };

    /**
     * (Re-)initialize message receiving for unit test mode
     */
    ms.updateReceiverOverride = function () {
      if (messageReceiverOverride && typeof messageReceiverOverride.registerOnMessage === 'function') {
        // testing and mocking
        messageReceiverOverride.registerOnMessage(receiveMessage);
      } // no else (handling here is not exclusive)
    };

    /**
     * Send message to receiver so the receiver can send back {@link TppMessageService.MessageType.EVENT} messages.
     */
    ms.connectApi = function (origin, callback) {
      var message = {
        tpp: {connectApi: true}
      };
      ms.send(message, origin, callback);
    };

    //init message handler
    if (typeof window !== 'undefined') {
      // Default case
      window.addEventListener('message', receiveMessage);
    }
    return ms;
  })();


  /**
   * Internal logging util. Stores enabled state within localStorage.
   * It can be enabled without code changes in the browsers dev console:
   * TPP_API.enableDebugLog().
   *
   * @private
   * @type {Function}
   */
  util.log = (function () {
    var LOCAL_STORAGE_DEBUG_LOG_ENABLED = 'tpp_debug_log_enabled';
    var _enabledFallback = false;
    var _isEnabled = function () {
      if (typeof localStorage !== 'undefined') {
        try {
          return localStorage.getItem(LOCAL_STORAGE_DEBUG_LOG_ENABLED) === 'true';
        } catch (e) {
          // localStorage not available
        }
      }
      return _enabledFallback;
    };

    var _setEnabled = function (enabled) {
      if (typeof localStorage !== 'undefined') {
        try {
          localStorage.setItem(LOCAL_STORAGE_DEBUG_LOG_ENABLED, enabled);
        } catch (e) {
          // localStorage not available
        }
      }
      _enabledFallback = enabled;
    };

    var _log = function debugLogger() {
      if (_isEnabled()) {
        var args = ['%cTPP:%c', 'font-style:italic', ''].concat([].slice.call(arguments));
        // noinspection JSUnresolvedFunction
        console.log.apply(console, args);
      }
    };

    _log.isEnabled = _isEnabled;
    _log.setEnabled = _setEnabled;

    return _log;
  })();

  // EventEmitter
  util.emit = function (eventName, detail, $target) {
    // noinspection JSCheckFunctionSignatures
    var event = new CustomEvent(eventName, {detail: detail, bubbles: true});
    $target = $target || document.body;
    $target.dispatchEvent(event);
    util.log("Event emitted", event);
  };


  //list the parsed results from previewId-Strings
  util.previewIdCache = function () {
    var _cache = {};

    var parsePreviewId = function (previewId) {
      try {
        var previewIdObjectString = atob(previewId);
        var previewIdObject = JSON.parse(previewIdObjectString);
        return JSON.parse(atob(previewIdObject['data-fs-id']));
      } catch (e) {
        util.log("Error in previewIdMatchesStatus for", previewId, e);
        return null;
      }
    };

    var getInfo = function (previewId) {
      if (!_cache[previewId]) {
        var fsIdObject = parsePreviewId(previewId);
        if (fsIdObject) {
          _cache[previewId] = fsIdObject;
        }
      }
      return _cache[previewId];
    };

    getInfo.clear = function () { _cache = {};};
    return getInfo;
  }();

  /**
   *
   * A light variant of underscore/lodash _.get().
   * Can read path expressions like
   *  * 'a'
   *  * 'a.b.c'
   *  * ['a','b','c']
   * But not:
   *  * 'a[1].b'
   *
   * Results:
   * * If object is null, undefined, or otherwise 'falsey'
   * * If path is null, undefined, an empty string, or not a string nor an array of String: undefined.
   * * Given a path 'a': object['a']
   * * Give a path 'a.b.c': getPath(['b','c'],object['a']);
   * * If path is []: undefined
   * * Given a path ['a']: object['a']
   * * Given a path ['a','b','c']: getPath(['b','c'],object['a']);
   * @protected
   * @param {string|[]} path
   * @param {Object} object
   * @return {*}
   */
  util.getValue = function (path, object) {
    if (!object || !path) {
      return undefined;
    }
    var pathSpec = [];
    if (typeof path === 'string') {
      pathSpec = path.split('.');
    } else if (path.constructor !== 'Array') {
      pathSpec = path;
    }
    if (pathSpec.length === 0) {
      return undefined;
    } else if (pathSpec.length === 1) {
      return object[pathSpec[0]];
    }
    return util.getValue(pathSpec.slice(1), object[pathSpec[0]]);
  };


  /**
   * The basic status object of a FirstSpirit element.
   * The documented properties are a subset and describe a fixed API.
   * Properties not documented here may change at any time.
   *
   * @example
   * {
   *  "storeType": "PAGESTORE",
   *  "elementType": "Page",
   *  "displayName": "_banner_xml",
   *  "uid": "_banner_xml",
   *  "released": true,
   *  "releaseSupported": true,
   *  "workflows" : {... }
   *  "permissions": { ... }
   * }
   *
   * @public
   * @since 1.0.0
   * @name TppElementStatus
   * @property {string} uid - the uid of the element
   * @property {string} displayName - the display name of the element
   * @property {string} elementType - the type of the element
   * @property {string} storeType - the type of the elements store
   * @property {boolean} releaseSupported - 'true' if the given element supports release
   * @property {boolean} release - the current release status of the element (value must be ignored if 'releaseSupported' is false)
   * @property {TppWorkflowStatus} workflows
   * @property {TppPermissionStatus} permissions
   **/


  /**
   * The descriptor of a FirstSpirit workflow.
   * @example
   *   {
   *      "uid": "Freigabe Anfordern",
   *      "displayName": "Release request",
   *      "storeType": "TEMPLATESTORE",
   *      "elementType": "Workflow",
   *      "permissions": {...}
   *      ...
   *   }
   *  @public
   *  @since 1.0.0
   *  @name TppWorkflowDescriptor
   *  @property {string} uid - the uid of the workflow
   *  @property {string} displayName - the display name of the workflow
   *  @property {string} storeType - the type of the elements store - in this case always "TEMPLATESTORE"
   *  @property {string} elementType - the type of the workflow - in this case always "Workflow"
   *  @property {TppPermissionStatus} permission - the current permissions on the workflow element itself
   */

  /**
   * The descriptor of a workflows transition.
   *
   *
   *
   * @example
   * {
   *    "id": "8",
   *    "displayName": "Check",
   *    "uid": "Prüfen"
   * }
   * @public
   * @since 1.0.0
   * @name TppTransitionDescriptor
   * @property {string} id - the id of the transition
   * @property {string} displayName - the display name of the transition
   * @property {string} uid - the uid of the element
   */

  /**
   * The current workflow status of the element. Containing running and possible workflows and their status.
   *
   * Called on a Page, the workflow status of the current page will be given.
   * Called on a Section, the workflow status of the page will be given, which contains the section.
   *
   * @example
   * {
   *    "allowed": [...],
   *    "current": {...},
   *    "transitions": [...],
   *    "deleteWorkflow": null
   * }
   * @public
   * @since 1.0.0
   * @name TppWorkflowStatus
   * @property {[TppWorkflowDescriptor]} allowed - list of all allowed workflows in the current element
   * @property {TppWorkflowDescriptor} current - gives the current running workflow of this element (can be null)
   * @property {[TppTransitionDescriptor]} transitions - gives a list a possible transitions in the running workflow (can be null)
   * @property {TppWorkflowDescriptor} deleteWorkflow - gives a dedicated deleteWorkflow for this element, if one is configured in the FirstSpirit project (can be null)
   **/


  /**
   * The permission of the current user on the given element.
   * @example
   *  {
   *    "see": true,
   *    "read": true,
   *    "change": true,
   *    "delete": true,
   *    "appendLeaf": true,
   *    "deleteLeaf": true,
   *    "release": true,
   *    "seeMeta": true,
   *    "changeMeta": true,
   *    "changePermission": true
   *  }
   * @public
   * @since 1.0.0
   * @name TppPermissionStatus
   * @property {boolean} see
   * @property {boolean} read
   * @property {boolean} change
   * @property {boolean} delete
   * @property {boolean} appendLeaf
   * @property {boolean} deleteLeaf
   * @property {boolean} release
   * @property {boolean} seeMeta
   * @property {boolean} changeMeta
   * @property {boolean} changePermission
   **/


  /**
   * Fluent builders to create typed objects.
   * Ensures the "interface" the object and should provide a stable API.
   *
   * @private Could be made part of the official api.
   */
  util.Types = (function () {

    /**
     * Internal representation if a concrete button action in the decorate API.
     *
     * Instances of action will be produced by the API.
     *
     * @public
     * @since 1.0.0
     * @name TppAction
     * @class
     */
    /**
     * @protected
     * @name TppActionBuilder
     * @example
     * var action = createActionBuilder().name('sendMail').execute(...).build();
     *
     * @return {TppActionBuilder}
     */
    var createActionBuilder = function () {

      var build = function (template) {

        var action = {};

        var _status = {};

        var conf = Object.create(template);

        action._typeMarker = 'TppAction';

        /**
         * The current status of the FirstSpirit element connected with this action.
         *
         * This object might be empty, if there is no current element given by a previewId or the
         * information is not fetched yet by using {@link TPP_API.Operation.getElementStatus}.
         *
         * To avoid null- and undefined-checks, the method provides an optional argument path to query a
         * nested object property.
         *
         * @example
         * action.getStatus()       // Give the object set with action.setStatus
         * action.getStatus("a.b")  // Gives action.getStatus().a.b, if value exists. Otherwise: undefined
         *
         * @public
         * @since 1.0.0
         * @name TppAction#getStatus
         * @method
         * @param {string} [path] - Optional property path to query on status
         * @return {TppElementStatus|*} - the status of the current element. Might be an empty object.
         */
        action.getStatus = function (path) {
          if (path) {
            return util.getValue(path, _status);
          }
          return _status;
        };

        /**
         * Set the current status of the action.
         *
         * @public
         * @since 1.0.0
         * @name TppAction#setStatus
         * @method
         * @param status
         */
        action.setStatus = function (status) {
          _status = status;
        };


        /**
         * The current name of the action.
         *
         * @public
         * @since 1.0.0
         * @name TppAction#getName
         * @method
         * @return {string}
         */
        action.getName = function () {
          return conf._name;
        };

        /**
         * The label of the action
         * @public
         * @since 1.0.0
         * @name TppAction#getLabel
         * @method
         * @return {string}
         */
        action.getLabel = function () {
          return conf._label;
        };

        /**
         * The icon url of the action
         * @public
         * @since 1.0.0
         * @name TppAction#getIcon
         * @method
         * @return {string}
         */
        action.getIcon = function () {
          return conf._icon;
        };

        /**
         * The preview id of the action
         * @public
         * @since 1.0.0
         * @name TppAction#getPreviewId
         * @method
         * @return {string} - can be null.
         */
        action.getPreviewId = function () {
          return conf._previewId;
        };

        /**
         * The current DOM element the action is attached to
         * @public
         * @since 1.0.0
         * @name TppAction#getElement
         * @method
         * @return {HTMLElement} - can be null
         */
        action.getElement = function () {
          return conf._element;
        };

        /**
         * The context of the action.
         * To avoid null- and undefined-checks, the method provides an optional argument path to query a
         * nested object property.
         *
         * @public
         * @since 1.0.0
         * @name TppAction#getContext
         * @method
         * @param {string} [path] - Optional property path to query on context
         * @return {Object}
         */
        action.getContext = function (path) {
          if (path) {
            return util.getValue(path, conf._context);
          }
          return conf._context;
        };

        /**
         * Check if the action is enabled
         * @public
         * @since 1.0.0
         * @name TppAction#isEnabled
         * @method
         * @return {boolean}
         */
        action.isEnabled = function () {
          if (typeof conf._isEnabled === 'function') {
            return !!(conf._isEnabled(action, Array.prototype.slice.call(arguments)));
          }
          return true;
        };

        /**
         * Execute the action
         * @public
         * @since 1.0.0
         * @name TppAction#execute
         * @method
         */
        action.execute = function () {
          if (typeof conf._execute === 'function') {
            return conf._execute(action, Array.prototype.slice.call(arguments));
          }
        };

        /**
         * Check if the action is configured with options.
         * Compare to {@link TppActionBuilder#options}.
         * @public
         * @since 1.0.0
         * @name TppAction#supportsOptions
         * @return {boolean}
         */
        action.supportsOptions = function () {
          return (!!conf._getOptions);
        };

        /**
         * Returns the action's possible options
         * @public
         * @since 1.0.0
         * @name TppAction#getOptions
         * @return {[TppActionOptions]}
         */
        action.getOptions = function () {
          if (typeof conf._getOptions === 'function') {
            return conf._getOptions(action, Array.prototype.slice.call(arguments));
          } else {
            return conf._getOptions; //fixme: freeze the array
          }
        };

        return action;

      };

      /**
       *
       * Creates a copy and sets the values.
       * This is used to make the builder immutable,
       * in the way that every chain-able function
       * gives a new instance of a builder keeping.
       *
       * Object.freeze is not used as an optimization,
       * because the we handle the template here as
       * "private" variable
       * @protected
       * @param {Object} template
       * @param {Object} values
       *
       */
      var builderWith = function (template, values) {
        var _template = Object.create(template);
        if (values) {
          _template = Object.assign(_template, values);
        }
        return createBuilder(_template);
      };


      /**
       * Fluent and immutable API to configure custom buttons.
       * Methods can be chained and they produce a new immutable
       * instance of an action builder.
       *
       * See {@link TPP_API.Button.CUSTOM} for more configuration examples.
       *
       * See {@link TppDecorator} and {@link TPP_API.Decorate.element} for
       *  normal use case in decorate Api.
       *
       * @example
       * // Basic API
       *
       * // 1. Configuration of a custom action
       * var actionBuilder = TPP_API.createActionBuilder()
       *        .name('sendMail')
       *        .execute(...)
       *        .options();

       * // 2. Immutable usage
       * var basic = TPP_API.createActionBuilder().
       *        .isEnable(elementIsWritable)
       *        .context({conf : "some common settings"});
       *
       * // The two following examples share the same basic properties.
       * // 2.1
       * var rotateActionBuilder = basic
       *       .options([{id:'left', label:'left'}, {id : right}])
       *       .execute(rotate);
       *
       * // 2.2
       * // basic action builder can be used here as well.
       * var flipActionBuilder = basic.execute(flip);
       *
       * @class
       * @public
       * @since 1.0.0
       * @name TppActionBuilder
       * @type {TppActionBuilder}
       */
      /**
       * @protected
       * @param {Object} template
       */
      var createBuilder = function (template) {

        var builder = {};
        builder._typeMarker = 'TppActionBuilder';

        /**
         * Internal button name, should be unique.
         * Will also be used for css classes.
         *
         * Defines the result of {@link TppAction#getName}
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#name
         * @method
         * @param {string} name The unique name of the button.
         * @return {TppActionBuilder}
         */
        builder.name = function (name) {
          return builderWith(template, {_name: name});
        };

        /**
         * Button label (Currently only used to title dropdown buttons).
         *
         * Defines the result of {@link TppAction#getLabel}.
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#label
         * @method
         * @param {string} label - The readable and translated label of the button.
         * @return {TppActionBuilder}
         */
        builder.label = function (label) {
          return builderWith(template, {_label: label});
        };

        /**
         * Provide context, available to action.
         *
         * This is intended to hold fixed configuration for the resulted actions.
         *
         * Variable data will be stored in {@link TppAction#getStatus}.
         * For this reason there is no method to set the status in the action builder but in the current
         * action itself {@link TppAction#setStatus}. And vice versa there is no method to set the context
         * in the {@link TppAction}.
         *
         * Defines the result of {@link TppAction#getContext}.
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#context
         * @method
         * @param {Object} context - An arbitrary object of user data.
         * @return {TppActionBuilder}
         */
        builder.context = function (context) {
          return builderWith(template, {_context: context});
        };


        /**
         * Update the provided context.
         *
         * This can be used, if the context has to be build up step by step.
         *
         * @name TppActionBuilder#updateContext
         * @public
         * @since 1.1.0
         * @param {Object} contextUpdate - The current object of user data will be updated by Object assign
         * @return {TppActionBuilder}
         * @example
         * builder
         *      .context({a:'foo', b:1});      // Set.      Context is now: {a: 'foo', b: 1}
         *      .updateContext({b: 2});        // Update.   Context is now: {a: 'foo', b: 2}
         *      .updateContext({c: 'bar'});    // Update.   Context is now: {a: 'foo', b: 2, c: 'bar'}
         *      .context({b: 3});              // Override. Context is now: {b: 3}
         *
         */
        builder.updateContext = function (contextUpdate) {
          var context = Object.assign({}, template._context, contextUpdate);
          return builderWith(template, {_context: context});
        };


        /**
         * This will be called internally when used in decorated elements.
         *
         * Defines the result of {@link TppAction#getElement}.
         *
         * It is not necessary to call this manually in the decorate use case.
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#element
         * @method
         * @param element
         * @return {TppActionBuilder}
         */
        builder.element = function (element) {
          return builderWith(template, {_element: element});
        };

        /**
         * Icon, dimension should be 24x24 pixels.
         *
         * Defines the result of {@link TppAction#getIcon}
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#icon
         * @param {string} url - The url of the buttons icon.
         * @return {TppActionBuilder}
         */
        builder.icon = function (url) {
          return builderWith(template, {_icon: url});
        };

        /**
         * This will be called internally when used in decorated elements.
         *
         * It is not necessary to call this manually in the decorate use case.
         *
         * Use {@link TppDecorator.updatePreviewId} instead to update the preview id for all actions
         * of one element.
         *
         * Defines the result of {@link TppAction#getPreviewId}
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#previewId
         * @method
         * @param {string} previewId - The preview id connected with the current action.
         * @return {TppActionBuilder}
         */
        builder.previewId = function (previewId) {
          return builderWith(template, {_previewId: previewId});
        };

        /**
         * Callback will get the current {@link TppAction} as first parameter.
         * The action is given to use the read only properties in this callback.
         * Like: {@link TppAction#getContext}, {@link TppAction#getStatus},
         * {@link TppAction#getOptions}, {@link TppAction#getName}.
         *
         * @public
         * @since 1.0.0
         * @callback TppAction~IsEnabledCallback
         * @param {TppAction} self - The action itself
         * @return {boolean} - true if the button should be enabled and visible.
         */
        /**
         * The call to {@link TppAction#isEnabled} will be delegated to
         * the given callback.
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#isEnabled
         * @method
         * @param {TppAction~IsEnabledCallback} isEnabled - An isEnabled callback
         * @return {TppActionBuilder}
         */
        builder.isEnabled = function (isEnabled) {
          return builderWith(template, {_isEnabled: isEnabled});
        };


        /**
         * Callback will get the current {@link TppAction} as first parameter.
         * The action is given to use the read only properties in this callback.
         * Like: {@link TppAction#getContext}, {@link TppAction#getStatus},
         * {@link TppAction#getOptions}, {@link TppAction#getName}.
         *
         * The arguments array of the {@link TppAction#execute} call will be given as second parameter.
         * Used in the decorate API: If the {@link TppAction} has options, the selected option will given
         * as first two parameters of this array.
         * @public
         * @since 1.0.0
         * @callback TppAction~ExecuteCallback
         * @param {TppAction} self - The action itself
         * @param {Array} args - An array of arguments given to the {@link TppAction#execute}.
         *      args[0] will be the selected Options id
         *      args[1] will be the selected Options label
         */
        /**
         * The call to {@link TppAction#execute} will be delegated to
         * the given callback. The decorate api binds this execute to its buttons or options.
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#execute
         * @method
         * @param {TppAction~ExecuteCallback} execute - An executeCallback
         * @return {TppActionBuilder}
         */
        builder.execute = function (execute) {
          return builderWith(template, {_execute: execute});
        };

        /**
         * A possible option of a drop down action.
         * The options contains a unique id and a redable and translated label.
         * @public
         * @since 1.0.0
         * @typedef {{id,label}} TppActionOptions
         */
        /**
         * Callback will get the current {@link TppAction} as first parameter.
         * The action is given to use the read only properties in this callback.
         * Like: {@link TppAction#getContext}, {@link TppAction#getStatus},
         * {@link TppAction#getOptions}, {@link TppAction#getName}.
         *
         *
         * The arguments array of the {@link TppAction#getOptions} call will be given as second parameter.
         *
         * @public
         * @since 1.0.0
         * @callback TppAction~GetOptionsCallback
         * @param {TppAction} self - The action itself
         * @param {Array} args - An array of arguments given to the TppAction#getOptions.
         * @return {[TppActionOptions]}
         */
        /**
         * The call to {@link TppAction#getOptions} will be delegated to
         * the given callback or will return the given array.
         * The callback can be used to calculate dynamic options.
         *
         * If the callback or array is given {@link TppAction#supportsOptions} returns true,
         * and a drop down button will be rendered with all given options, instead of a simple button.
         *
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#options
         * @param {TppAction~GetOptionsCallback|[TppActionOptions]} getOptions - Either a callback or a static list of TppActionOptions
         * @return {TppActionBuilder}
         */
        builder.options = function (getOptions) {
          return builderWith(template, {_getOptions: getOptions});
        };

        /**
         * Alias for {@link TppActionBuilder#options}.
         * @public
         * @since 1.0.0
         * @name TppActionBuilder#getOptions
         * @param {TppAction~GetOptionsCallback|[TppActionOptions]} getOptions - Either a callback or a static list of TppActionOptions
         * @return {TppActionBuilder}
         */
        builder.getOptions = builder.options;

        /**
         * Gives a new instance of {@link TppAction}.
         *
         * It is not necessary to call this manually in the decorate use case.
         *
         * @protected
         * @name TppActionBuilder#build
         * @method
         * @return {TppAction}
         */
        builder.build = function () {
          return build(template);
        };

        return builder;
      };

      var defaultIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjEwMPRyoQAAAF1JREFUOE/t00sKACAIRVH3v2n7UNFIb4qzgmZ6kIeKqkrFL0HHoB8+CdAoemzz0Xqc8YYxTie4YYRHYRfPwCaegc3eKOz2uQVrxcq3gg6C9xiD+4ieG+j1ffgk0AB67wNERdYKGwAAAABJRU5ErkJggg==";

      var initialTemplate = {
        _name: null,
        _label: null,
        _previewId: null,
        _element: null,
        _context: {},
        _isEnabled: null,
        _execute: null,
        _getOptions: null,
        _icon: defaultIcon
      };

      return builderWith({}, initialTemplate);
    };


    var actionHelper = (/**
     *
     * Convenience functions to create actions from builder
     * @protected
     * @return {{create}}
     */
    function () {
      var createActionFromBuilder = function (builder, context) {
        if (typeof context === 'object') {
          return builder.context(context).build();
        } else {
          return builder.build();
        }
      };

      var actionSpecToBuilder = function (actionSpec) {
        if (actionSpec['_typeMarker'] === 'TppActionBuilder') {
          return actionSpec;
        }
        if (typeof actionSpec === 'function') {
          var builder = actionSpec(util.Types.createActionBuilder());
          if (typeof builder === 'undefined') {
            util.log("TppActionBuilderCallback has to return the buttonBuilder!");
            return null;
          }
          return builder;
        }
      };

      /**
       * @return {TppAction}
       */
      var create = function (actionSpec, context) {
        var action = null;
        var actionBuilder = actionSpecToBuilder(actionSpec);
        if (actionBuilder) {
          action = createActionFromBuilder(actionBuilder, context);
        }
        if (actionSpec['_typeMarker'] === 'TppAction') {
          if (!context) {
            action = actionSpec;
          } else {
            util.log("Illegal arguments context not allowed with given action");
          }
        }
        return action
      };

      return {
        create: create,
        actionSpecToBuilder: actionSpecToBuilder
      };

    })();

    return {
      createActionBuilder: createActionBuilder,
      actionHelper: actionHelper
    };
  })();


  util.path = function (pathString) {
    if (typeof pathString !== 'string') {
      return null;
    }
    var elements = pathString
      .split('/')
      .filter(function (element) {return (element.length > 0); });

    if (elements.length === 0) {
      return null;
    }

    var isFolder = (pathString[pathString.length - 1] === '/');
    return {
      raw: pathString,
      isFolder: isFolder,
      normalized: elements.join('/'),
      parent: elements.slice(0, -1).join('/'),
      name: elements[elements.length - 1]
    };
  };


  /**
   * DOM manipulations to create the user interface.
   *
   * @private
   * @type {{renderFrame, renderButtons}}
   */
  util.ui = (function () {

    var ui = {};

    var hasClass = function (element, className) {
      if (element.classList) {
        return element.classList.contains(className);
      } else {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
      }
    };

    var addClass = function (element, className) {
      if (element.classList) {
        element.classList.add(className);
      } else {
        element.className += ' ' + className;
      }
    };

    var removeClass = function (element, className) {
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
    };


    /**
     * Adds an interactive/mouseover frame to a given element of the external app.
     * @private
     * @function
     */
    ui.renderFrame = function ($el) {

      var tppFrameDecorator = {};

      var $borders = document.body.appendChild(document.createElement('div'));
      $borders.className = 'tpp-borders';

      var $buttonContainer = $borders.appendChild(document.createElement('div'));
      $buttonContainer.className = 'tpp-buttons-container';

      var $activeElement = null;

      var drawBorders = function () {
        if ($activeElement !== null) {
          var rect = $activeElement.getBoundingClientRect();
          $borders.setAttribute('style', 'opacity: 1; ' + ['top', 'left', 'width', 'height'].map(function (prop) {
            return prop + ': ' + (prop === 'height' ? Math.max(rect[prop], 27) : rect[prop]) + 'px;'
          }).join(' '));
          $buttonContainer.setAttribute('style', 'display: block; ' + ['top', 'left', 'width'].map(function (prop) {
            return prop + ': ' + rect[prop] + 'px;'
          }).join(' '));
        }
      };

      var hideBorders = function () {
        $borders.setAttribute('style', 'transition: all 0s;');
        $buttonContainer.removeAttribute('style');
      };

      // we expect a window here
      window.addEventListener('scroll', drawBorders);

      var enter = function () {
        $activeElement = $el;
        drawBorders();
      };

      var leave = function () {
        $activeElement = null;
        setTimeout(function () {
          if ($activeElement === null) {
            hideBorders();
          }
        }, 0);
      };

      $el.addEventListener('mouseenter', enter);
      $buttonContainer.addEventListener('mouseenter', enter);

      $el.addEventListener('mouseleave', leave);
      $buttonContainer.addEventListener('mouseleave', leave);

      tppFrameDecorator.getButtonContainer = function () {
        return $buttonContainer;
      };
      tppFrameDecorator.disposeBorders = function () {
        var tppBorders = $buttonContainer.parentElement;
        if (tppBorders.parentElement) {
          tppBorders.parentElement.removeChild(tppBorders);
        }
      };

      return tppFrameDecorator;
    };


    /**
     * @typedef {{addButton, clearButtons, updateButtons}} TppButtonDecorator
     */
    /**
     * Add buttons panel to the given container element.
     * @private
     * @param $container
     * @returns {TppButtonDecorator}
     */
    ui.renderButtons = function ($container) {

      var $buttons = $container.appendChild(document.createElement('span'));
      $buttons.className = 'tpp-buttons';

      /** @type {[]} */
      var _buttons = [];
      /** @type {[]} */
      var _dropdownButtons = [];

      /** @type TppButtonDecorator */
      var buttonBuilder = {};

      var _updateButton = function (status, button) {
        button.action.setStatus(status);
        button.$element.dataset.enabled = button.action.isEnabled();
        if (button.action.isEnabled()) {
          if (hasClass(button.$element, 'tpp-disabled')) {
            removeClass(button.$element, 'tpp-disabled');
          }
        } else {
          if (!hasClass(button.$element, 'tpp-disabled')) {
            addClass(button.$element, 'tpp-disabled');
          }
        }
      };

      var _updateDropdownButton = function (status, button) {
        _updateButton(status, button);
        var action = button.action;
        var options = action.getOptions();
        var $flyout = button.$flyout;
        $flyout.innerHTML = '';

        var $grouptitle = $flyout.appendChild(document.createElement("div"));
        addClass($grouptitle, "tpp-workflow-grouptitle");
        $grouptitle.innerHTML = action.getLabel();

        var $list = $flyout.appendChild(document.createElement("ul"));
        options.map(function (option) {
          var $option = document.createElement("li");
          $option.innerHTML = option.label;
          $option.addEventListener('click', function () {
            action.execute(option.id, option.label);
          });
          $list.appendChild($option)
        });
      };


      /**
       * Creates a button in the given button bar
       * @private
       * @param {TppAction} action
       * @return {void}
       */
      var _addSimpleButton = function (action) {
        var $button = $buttons.appendChild(document.createElement('span'));
        addClass($button, 'tpp-button');
        addClass($button, 'tpp-disabled');
        addClass($button, "tpp-" + action.getName());
        $button.dataset.actionName = action.getName();
        $button.dataset.enabled = 'false';

        $button.addEventListener('click', function () {
          action.execute();
        });

        _buttons.push({
                        $element: $button, action: action
                      });
        appendActionIcon($button, action.getIcon());
      };


      /**
       * Creates a drop down button in the given button bar
       * @private
       * @param {TppAction} action
       * @return {void}
       */
      var _addDropdownButton = function (action) {
        var $flyout = $container.appendChild(document.createElement("div"));
        addClass($flyout, 'tpp-workflow-flyout');
        $flyout.addEventListener('mouseover', function () {
          addClass($flyout, 'selected');
        });
        $flyout.addEventListener('mouseout', function () {
          removeClass($flyout, 'selected');
        });


        var $button = $buttons.appendChild(document.createElement('span'));
        addClass($button, 'tpp-button');
        addClass($button, 'tpp-disabled');
        addClass($button, 'tpp-' + action.getName());
        $button.dataset.actionName = action.getName();
        $button.dataset.enabled = 'false';

        $button.addEventListener('mouseover', function () {
          addClass($flyout, 'selected');
          $flyout.style.left = ($button.getBoundingClientRect().left - $container.getBoundingClientRect().left - $flyout.getBoundingClientRect().width + $button.getBoundingClientRect().width) + "px";
        });

        $button.addEventListener('mouseout', function () {
          removeClass($flyout, 'selected');
        });

        _dropdownButtons.push({
                                $element: $button, $flyout: $flyout, action: action
                              });
        appendActionIcon($button, action.getIcon());
      };


      var appendActionIcon = function (element, iconUrl) {
        var $image = element.appendChild(document.createElement("img"));
        $image.src = iconUrl;
      };

      /**
       * @name TppButtonDecorator.updateButtons
       * @type TppButtonDecorator.updateButtons
       * @private
       */
      buttonBuilder.updateButtons = function (status) {
        _buttons.forEach(function (button) {
          _updateButton(status, button);
        });
        _dropdownButtons.forEach(function (button) {
          _updateDropdownButton(status, button);
        });

      };

      /**
       * @name TppButtonDecorator.clearButtons
       * @private
       */
      buttonBuilder.clearButtons = function () {
        _buttons = [];
        _dropdownButtons = [];
        $buttons.innerHTML = '';
      };


      /**
       * @public
       * @since 1.0.0
       * @callback TppActionBuilderCallback
       * @param {TppActionBuilder} _
       * @return {undefined|TppActionBuilder}
       */
      /**
       * @name TppButtonDecorator.addButton
       * @private
       * @param {TppAction|TppActionBuilder|TppActionBuilderCallback} buttonSpec
       * @param {Object} [context]
       * @return {Object} the created action (can be null)
       */
      buttonBuilder.addButton = function (buttonSpec, context) {

        var action = util.Types.actionHelper.create(buttonSpec, context);
        if (action) {
          if (action.supportsOptions()) {
            _addDropdownButton(action);
          } else {
            _addSimpleButton(action);
          }
        } else {
          util.log("Could not create action from buttonSpec", buttonSpec);
        }
        return buttonBuilder;
      };


      return buttonBuilder;
    };

    return ui;

  })();

  //Internal collection of action creators
  var ActionStore = {};


  // noinspection JSUnusedLocalSymbols to provide same signature for each API component
  /**
   * Basic TPP functions
   *
   * @name TPP_API.Common
   * @public
   * @since 1.0.0
   */
  function Common(api, util, config) {
    //This constructor takes api, util and config for better testability

    var common = this;

    var _previewRequestHandlers = [];
    var _navigationChangeHandlers = [];
    var _workflowProcessedHandlers = [];

    var _language = null;


    var fireDOMEvents = function (previewId, event, detail) {
      if (!!previewId) {
        util.previewElements()
          .filter(util.filter.byId(previewId))
          .forEach(function ($target) {
            util.emit(event, detail, $target);
          });
      }

      if (typeof document !== 'undefined' && typeof document.body !== 'undefined') {
        util.emit(event, detail, document.body);
      }
    };

    var fireStatusUpdates = function (response) {

      util.previewElements()
        .map(util.filter.matchAffectedInfo(response))
        .filter(util.filter.byNonEmpty)
        .forEach(function (affectedInfo) {
          var detail = {previewId: affectedInfo.previewId, status: affectedInfo.status, context: null};
          util.emit(api.Event.STATUS_CHANGED, detail, affectedInfo.$target);
        });
    };

    /**
     * @name TppInternalEventHandler.TPP_PREVIEW_REQUEST
     * @private
     */
    util.messageService.setInternalEventHandler('TPP_PREVIEW_REQUEST', function (payload) {
      if (!payload.error) {
        var previewId = payload.object;
        var detail = {previewId: previewId};
        fireDOMEvents(previewId, api.Event.ELEMENT_REQUESTED, detail);
        _previewRequestHandlers.forEach(function (handler) {handler(previewId);});
      }
    });

    /**
     * @name TppInternalEventHandler.TPP_NAVIGATION_CHANGED
     * @private
     */
    util.messageService.setInternalEventHandler('TPP_NAVIGATION_CHANGED', function (payload) {
      if (!payload.error) {
        var previewId = payload.object;
        var detail = {previewId: previewId};
        fireDOMEvents(previewId, api.Event.NAVIGATION_CHANGED, detail);
        _navigationChangeHandlers.forEach(function (handler) {handler(previewId);})
      }
    });

    /**
     * @name TppInternalEventHandler.TPP_WORKFLOW_ACTION
     * @private
     */
    util.messageService.setInternalEventHandler('TPP_WORKFLOW_ACTION', function (payload) {
      if (!payload.error) {
        var workflowInfo = payload.object;
        var previewId = workflowInfo.previewId;
        if (workflowInfo.isDeleted) {
          var detail = {
            previewId: workflowInfo.previewId,
            context: null,
            deleted: true
          };
          fireDOMEvents(previewId, api.Event.ELEMENT_DELETED, detail);
        } else {
          var detail = {
            previewId: workflowInfo.previewId,
            workflowId: workflowInfo.workflowId,
            transitionId: workflowInfo.transitionId
          };
          fireDOMEvents(previewId, api.Event.WORKFLOW_PROCESSED, detail);
          _workflowProcessedHandlers.forEach(function (handler) {handler(detail);});
          // Status Update for all affected elements
          api.Operation.getAffectedWorkflowElements(previewId)
            .then(function (affectedElements) {
              fireStatusUpdates(affectedElements);
            });
        }
      }
    });


    /**
     * Provides access to the WE_API's execute method.
     *
     * The result can be fetched by giving a callback function.
     * If this callback is not set, the function returns a Promise.
     * These are exclusive options.
     *
     * @name TPP_API.Common.execute
     * @public
     * @since 1.0.0
     * @param {string} identifier
     * @param {Object} params
     * @param {Function} [callback] if callback is set, this will be called.
     * @return {Promise|undefined} if callback is not set, this returns a promise
     */
    common.execute = function (identifier, params, callback) {
      var message = {
        tpp: {
          execute: identifier,
          params: params || {}
        }
      };
      if (util.isFunction(callback)) {
        util.messageService.send(message, config.origin, callback);
      } else {
        return new Promise(function (resolve) {
          util.messageService.send(message, config.origin, resolve);
        });
      }
    };

    /**
     * Sets Element the ContentCreator should handle as preview element.
     * The PreviewElement of the ContentCreator is given by a PageRef.
     *
     * This has to be controlled by the third party app because a "page" in the third party app can possibly contain
     * several first spirit page refs.
     *
     * This delegates to WE_API.Common.setPreviewElement
     *
     * @name TPP_API.Common.setPreviewElement
     * @public
     * @since 1.1.0
     * @param {string} previewId
     * @param {Function} [callback] if callback is set, this will be called when preview element is set
     * @return {Promise|undefined} if callback is not set, this return a promise
     */
    common.setPreviewElement = function (previewId, callback) {
      var message = {
        tpp: {
          setPreviewElement: true,
          previewId: previewId
        }
      };
      if (typeof callback === 'function') {
        util.messageService.send(message, config.origin, callback);
      } else {
        return new Promise(function (resolve) {
          util.messageService.send(message, config.origin, resolve);
        });
      }
    };

    /**
     * A callback equivalent to the {@link TPP_API.Event.NAVIGATION_CHANGED}.
     * @public
     * @since 1.1.0
     * @callback TPP_API.Common~PreviewRequestHandler
     * @param {string} previewId
     **/
    /**
     * This can be used to register a handler in case in the ContentCreator a new PreviewElement is requested.
     * This will be triggered for example if an element in a report or search will be triggered via click.
     *
     * How to handle this situation depends on the setup of the third party app. It could be ignored completely, a page
     * reload could be triggered, or an internal re-route without a full page refresh could be triggered.
     *
     * Compare TPP to standard ContentCreator behavior.
     *
     * If TPP is not enabled:
     * * The page change will be triggered by navigating in the preview page or by a click in a report.
     * * The URL of the preview iframe will be changed.
     * * The Page reloads.
     * * The listener of {@link https://docs.e-spirit.com/odfs/template-develo/javascript-apis/contentcreator/common-function/index.html#auf_seitenwechsel_reagieren|WE_API.Common.addPreviewElementListener}
     * * will be called with an FSID as parameter.
     *
     * If TPP is enabled:
     * * The page change will be requested by the a click in a reporter.
     * * The handler of {@link TPP_API.Common.addPreviewRequestHandler|this} very method will be called with a previewId.
     * * The third party app can decide, how to react.
     * * It could ignore the previewId, make a full page refresh, or change the route.
     * * It could notify the ContentCreator that the preview element has changed by calling {@link TPP_API.Common.setPreviewElement}.
     * * This would trigger the listener of {@link https://docs.e-spirit.com/odfs/template-develo/javascript-apis/contentcreator/common-function/index.html#auf_seitenwechsel_reagieren|WE_API.Common.addPreviewElementListener}.
     *
     * @name TPP_API.Common.addPreviewRequestHandler
     * @public
     * @since 1.1.0
     * @param {TPP_API.Common~PreviewRequestHandler} callback
     */
    common.addPreviewRequestHandler = function (callback) {
      if (util.isFunction(callback)) {
        _previewRequestHandlers.push(callback);
        util.log('Registered a new Preview Request Handler');
      }
    };


    /**
     * A callback equivalent to the {@link TPP_API.Event.NAVIGATION_CHANGED}.
     * @public
     * @since 1.1.0
     * @callback TPP_API.Common~NavigationChangeCallback
     * @param {string} [previewId] - if a new page ref is created the previewId of this PageRef will be send here.
     **/
    /**
     * Callback is called when there are changes in the SiteStore triggered in the outer ContentCreator.
     *
     * @name TPP_API.Common.addNavigationChangeHandler
     * @public
     * @since 1.1.0
     * @param {TPP_API.Common~NavigationChangeCallback} callback
     */
    common.addNavigationChangeHandler = function (callback) {
      if (util.isFunction(callback)) {
        _navigationChangeHandlers.push(callback);
        util.log('Registered a new Navigation Request Handler');
      }
    };


    /**
     * A callback equivalent to the {@link TPP_API.Event.WORKFLOW_PROCESSED}.
     * @public
     * @callback TPP_API.Common~WorkflowProcessedCallback
     * @param {{previewId, transitionId}} [info] - event info about transition, and the element it is processed on
     **/
    /**
     * Callback is called every time a workflow step was triggered.
     *
     * @name TPP_API.Common.addWorkflowProcessedHandler
     * @public
     * @param {TPP_API.Common~WorkflowProcessedCallback} callback
     */
    common.addWorkflowProcessedHandler = function (callback) {
      if (util.isFunction(callback)) {
        _workflowProcessedHandlers.push(callback);
        util.log('Registered a new Workflow Processed Handler');
      }
    };


    /**
     * @private internal test method; can be used to check backend and frontend API version
     */
    common.ping = function (callback) {

      util.log('Sending PING from fs-tpp-api.js. Version: ' + FRONTEND_VERSION);

      var callbackWrapper = function (result) {
        util.log('Receiving PONG from fs-tpp-api-Module. Version: ' + (result.version || 'UNKNOWN'));
        if (typeof callback === 'function') {
          callback(result);
        }
      };

      var message = {
        tpp: {ping: true, version: FRONTEND_VERSION}
      };

      util.messageService.send(message, config.origin, callbackWrapper);
    }
  }


  // noinspection JSUnusedLocalSymbols
  /**
   * Provides operations on store elements represented by previewIds.
   * This contains operations to Create, Read, Edit, Delete, and to do workflow stuff on store elements.
   * @name TPP_API.Operation
   * @public
   * @since 1.0.0
   */
  function Operation(api, util, config) {
    //This constructor takes api, util and config for better testability

    var operation = this;
    var _project = { languages: [], previewUrl: location.href };

    var EXECUTABLE = 'class:TppApi';

    // All actions provided by class:TppApi
    var Action = {
      EDIT: 'EDIT',
      EDIT_META_DATA: 'EDIT_META_DATA',
      STATUS: 'STATUS',
      DELETE: 'DELETE',
      DELETE_WORKFLOW: 'DELETE_WORKFLOW',
      RENDER: 'RENDER',
      CREATE_PAGE: 'CREATE_PAGE',
      CREATE_SIBLING_SECTION: 'CREATE_SIBLING_SECTION',
      CREATE_CHILD_SECTION: 'CREATE_CHILD_SECTION',
      CREATE_DATASET: 'CREATE_DATASET',
      WORKFLOW_START: 'WORKFLOW_START',
      WORKFLOW_PROCESS: 'WORKFLOW_PROCESS',
      CROP_IMAGE: 'CROP_IMAGE',
      TOGGLE_BOOKMARK: 'TOGGLE_BOOKMARK',
      PROJECT_INFO: 'PROJECT_INFO',
      TRANSLATION: 'TRANSLATION'
    };


    var createDetail = function (previewId, context, detailName, response) {
      var detail = {
        previewId: previewId || null,
        context: context || null
      };
      detail[detailName] = response;
      return detail;
    };


    var executeOperation = function (params) {
      return api.Common.execute(EXECUTABLE, params).then(function (response) {
        if (response.error) {
          return Promise.reject(response.object);
        } else {
          return Promise.resolve(response.object);
        }
      });
    };

    executeOperation({ action: Action.PROJECT_INFO }).then(function(response) {
      if(response){
        _project.previewUrl = response.previewUrl;
        response.languages.forEach(function(language) {
          if (language.master) {
            _project.languages.unshift(language.lang);
          } else {
            _project.languages.push(language.lang);
          }
        });
      }
    });

    /**
     * @name TPP_API.Operation.getAffectedWorkflowElements
     * @protected
     */
    operation.getAffectedWorkflowElements = function (previewId) {
      var params = {
        action: 'GET_AFFECTED_WORKFLOW_ELEMENTS',
        previewId: previewId,
        workflowMode: config.workflowMode
      };
      return executeOperation(params);
    };

    /**
     * Shows a ContentCreator EditDialog for the store element specified by the previewId.
     * Produce a {@link #eventtpp_apieventstatus_changed|TPP_API.Event.STATUS_CHANGED} event on all elements annotated with the given previewId.
     * Returns the changed content of the given store element as Promise result.
     *
     * @name TPP_API.Operation.showEditDialog
     * @public
     * @since 1.0.0
     * @example
     *
     *  //Example 1: Edit and update DOM manually
     *  var previewId = ...;
     *  TPP_API.Operation
     *    .showEditDialog(previewId)
     *    .then(content => $(`[data-fs-preview-id=${previewId}]`).innerHTML( App.render(content) ));
     *
     *  //Example 2: Edit and Update via Event
     *  $(document).on(TPP_API.Event.CONTENT_CHANGED, (e)=>{
     *    //Merge content with external data
     *    var productInfo = App.getProductInfo(e.context.productId);
     *    App.render(e.target, e.detail.content, productInfo);
     *  });
     *
     *  TPP_API.Operation
     *    .showEditDialog(previewId, {productId: 23});
     *
     *
     * @fires TPP_API.Event.CONTENT_CHANGED
     * @param {string} previewId - The previewId of the store element
     * @param {any} [context] - A custom context that will be passed to every fired event.
     * @return {Promise} The rendered content.
     */
    operation.showEditDialog = function (previewId, context) {

      var params = {
        action: Action.EDIT,
        previewId: previewId
      };

      return executeOperation(params)
        .then(function (response) {
          if (response !== null) {
            // force refresh of preview element to reflect changed state
            api.Common.setPreviewElement();

            util.previewElements()
              .filter(util.filter.byId(previewId))
              .forEach(function ($target) {
                var detail = createDetail(previewId, context, 'content', response);
                util.emit(api.Event.CONTENT_CHANGED, detail, $target);
              });
          }
          return response;
        });

    };

    /**
     * Shows a ContentCreator EditDialog for the MetaData of the store element specified by the previewId.
     * Produce a {@link #eventtpp_apieventstatus_changed|TPP_API.Event.STATUS_CHANGED} event on all elements annotated with the given previewId.
     * Returns the changed content of the given store element as Promise result.
     *
     * MetaData providing elements have to be configured. For the necessary steps in ContentCreator see https://docs.e-spirit.com/odfs/edocs/admi/firstspirit-ser/project-propert/contentcreator/index.html#text_bild_14.
     *
     * @name TPP_API.Operation.showMetaDialog
     * @public
     * @since 1.2.1
     *
     * @fires TPP_API.Event.CONTENT_CHANGED
     * @param {string} previewId - The previewId of the store element
     * @param {any} [context] - A custom context that will be passed to every fired event.
     * @return {Promise} The rendered content.
     */
    operation.showMetaDataDialog = function (previewId, context) {

      var params = {
        action: Action.EDIT_META_DATA,
        previewId: previewId
      };

      return executeOperation(params)
        .then(function (response) {
          if (response !== null) {
            // force refresh of preview element to reflect changed state
            api.Common.setPreviewElement();

            util.previewElements()
              .filter(util.filter.byId(previewId))
              .forEach(function ($target) {
                var detail = createDetail(previewId, context, 'content', response);
                util.emit(api.Event.CONTENT_CHANGED, detail, $target);
              });
          }
          return response;
        });

    };


    /**
     * Request the status of the store element specified by the previewId.
     * Produce a {@link #eventtpp_apieventstatus_changed|TPP_API.Event.STATUS_CHANGED} event on all elements annotated with the given previewId.
     * Returns a status object as Promise result.
     *
     * @name TPP_API.Operation.getElementStatus
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.STATUS_CHANGED
     * @param {string} previewId - The previewId of the store element.
     * @param {any} [context] - A custom context that will be passed to every fired event.
     * @return {Promise} A status object (Currently unstable API)
     */
    operation.getElementStatus = function (previewId, context) {

      var params = {
        action: Action.STATUS,
        previewId: previewId,
        workflowMode: config.workflowMode
      };

      return executeOperation(params)
        .then(function (response) {
          util.previewElements()
            .filter(util.filter.byId(previewId))
            .forEach(function ($target) {
              var detail = createDetail(previewId, context, 'status', response);
              util.emit(api.Event.STATUS_CHANGED, detail, $target);
            });
          return response;
        });

    };

    /**
     * Request the content of the store element specified by the previewId.
     * Produces a {@link TPP_API.Event.CONTENT_CHANGED} event on all elements with the given previewId.
     * Gives the rendered Content as Promise-result.
     *
     * @name TPP_API.Operation.renderElement
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.CONTENT_CHANGED
     * @param {string} previewId - The previewId of the store element.
     * @param {any} [context] - A custom context that will be passed to every event fired.
     * @return {Promise|*} The rendered content of the element as Promise result.
     */
    operation.renderElement = function (previewId, context) {

      var params = {
        action: Action.RENDER,
        previewId: previewId
      };

      return executeOperation(params)
        .then(function (response) {
          util.previewElements()
            .filter(util.filter.byId(previewId))
            .forEach(function ($target) {
              var detail = createDetail(previewId, context, 'content', response);
              util.emit(api.Event.CONTENT_CHANGED, detail, $target);
            });
          return response;
        });

    };

    /**
     * Renders the start node of the project without knowing its previewId -
     * as one possibility to fetch bootstrap information.
     *
     * This is a best practise approach but nothing more.
     * The bootstrap process highly depends on your overall project architecture.
     *
     * Fires no event.
     *
     * @param {string} language - The language for the rendering.
     * @return {Promise} The rendered content of the start node (root of site store) as Promise result.
     * @name TPP_API.Operation.renderStartNode
     */
    operation.renderStartNode = function (language) {
      return executeOperation({action: 'RENDER_START_NODE', language: language});
    };

    /**
     * Deletes a store element specified by its previewId.
     * Produces a {@link TPP_API.Event.ELEMENT_DELETED} event on all elements annotated with the given previewId.
     * Returns a boolean to indicate success or failure as Promise result.
     *
     * @name TPP_API.Operation.deleteSection
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.ELEMENT_DELETED
     * @param {string} previewId - The previewId of the store element
     * @param {any} [context} - A custom context that will be passed to every fired event.
     * @return {Promise} A boolean; true if delete was successful.
     */
    operation.deleteSection = function (previewId, context) {
      var params = {
        action: Action.DELETE,
        previewId: previewId
      };

      return executeOperation(params)
        .then(function (response) {
          if (response === true) {
            util.previewElements()
              .filter(util.filter.byId(previewId))
              .forEach(function ($target) {
                var detail = createDetail(previewId, context, 'deleted', response);
                util.emit(api.Event.ELEMENT_DELETED, detail, $target);
              });
          }
          return response;
        });
    };

    /**
     * Starts a delete workflow for a page.
     *
     * @name TPP_API.Operation.deletePage
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.WORKFLOW_PROCESSED
     * @param {string} previewId - The previewId of the store element
     * @param {string} deleteWorkflowUID - Uid of the delete workflow.
     * @param {any} [context} - A custom context that will be passed to every event fired.
     * @return {Promise} A boolean; true if delete was successful.
     */
    operation.deletePage = function (previewId, deleteWorkflowUID, context) {
      var params = {
        action: Action.DELETE_WORKFLOW,
        previewId: previewId,
        workflowMode: config.workflowMode
      };
      if (config.deletePageWorkflow !== null) {
        params["workflowUID"] = config.deletePageWorkflow;
      }


      return executeOperation(params);

    };

    /**
     * Shows a ContentCreator WorkflowDialog that can be used to start a certain workflow specified by
     * its workflow id and based on the given previewId.
     *
     * If previewId addresses a page element, the workflow is started on that page element.
     * If the previewId addresses a section element, the workflow is started on the page element that
     * contains the section.
     *
     * Produces a {@link TPP_API.Event.WORKFLOW_PROCESSED} event on all elements annotated with the given previewId.
     *
     * Produces a {@link #eventtpp_apieventstatus_changed|TPP_API.Event.STATUS_CHANGED} event on all elements annotated with a previewId that are affected by the
     * workflow. Affected by the workflow are the page and all sections contained in it (this includes the
     * element addressed by the given previewId).
     *
     * Returns an array of status objects for all affected elements as Promise result.
     *
     * @name TPP_API.Operation.startWorkflow
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.WORKFLOW_PROCESSED
     * @param {string} previewId - The previewId of the store element
     * @param {string} workflow - The uid or id of the workflow to start
     * @param {any} [context] - A custom context that will be passed to every fired event.
     * @return {Promise} A WorkflowChanged object which holds a list of status elements -
     *                      one for every element affected by the process.
     */
    operation.startWorkflow = function (previewId, workflow, context) {
      var params = {
        action: Action.WORKFLOW_START,
        previewId: previewId,
        workflow: workflow,
        workflowMode: config.workflowMode
      };
      return executeOperation(params);
      /**
       *  Event Handling will be triggered by external event
       *  See event Handler for TPP_WORKFLOW_ACTION {@link TppInternalEventHandler.TPP_WORKFLOW_ACTION}
       */
    };


    /**
     * Processes a running workflow specified by a transition and a store element's previewId.
     *
     * If previewId addresses a page element, then the workflow is continued on that page element.
     * The previewId addresses a section element, then the workflow is continued on the page element that
     * contains the section.
     *
     *
     * Produces a {@link TPP_API.Event.WORKFLOW_PROCESSED} event on all element annotated with the given previewId.
     *
     * Produces a {@link #eventtpp_apieventstatus_changed|TPP_API.Event.STATUS_CHANGED} event on all element annotated with a previewId that is affected by the
     * workflow. Affected by the workflow are the page and all contained sections (which includes the
     * element addressed by the given previewId).
     *
     * Returns a object holding a list of status elements for all affected elements as Promise result.
     *
     *
     * @name TPP_API.Operation.processWorkflow
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.WORKFLOW_PROCESSED
     * @param {string} previewId - The previewId of the store element
     * @param {string} transition - The uid or id of the transition to process as workflow step
     * @param {any} [context] - A custom context that will be passed to every fired event.
     * @return {Promise} A WorkflowChanged object which holds a list of status elements
     *                      for every element that was affected by the process.
     */
    operation.processWorkflow = function (previewId, transition, context) {

      var params = {
        action: Action.WORKFLOW_PROCESS,
        previewId: previewId,
        transition: transition,
        workflowMode: config.workflowMode
      };

      return executeOperation(params);
      /**
       *  Event Handling will be triggered by external event
       *  See event Handler for TPP_WORKFLOW_ACTION {@link TppInternalEventHandler.TPP_WORKFLOW_ACTION}
       */
    };

    /**
     * @protected
     * @typedef {Object} TppCreatePageConfig
     * @property {string} path
     * @property {string} template
     * @property {string} language
     */
    /**
     * Default way to create a new page.
     *
     * The signature is a little different from the other operations because we do not have
     * a previewId for the element yet.
     *
     * The operation starts a page creation with the following behavior:
     *  * An editor for the newly created page will be opened
     *  * The language to edit, can be set optionally with config.language.
     *  * A Page is created with the specified path, and the last path element is used as uid for the page
     *    (for the page template see below).
     *  * A PageRef referencing this Page is created with the same path as the page.
     * The Template for the Page will be given by config.template, but can be overridden by the selectedTemplate
     * parameter. The template is specified by its uid.
     *
     * @name TPP_API.Operation.createPage
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.ELEMENT_CREATED
     * @param {HTMLElement} [$element] - The related element to fire the event on.
     * @param {TppCreatePageConfig} config - Configures the creation of the page
     * @param {string} [selectedTemplate] - Overrides the template given in config
     * @return {Promise}
     */
    operation.createPage = function ($element, config, selectedTemplate) {
      var path = util.path(config.path);
      if (path === null) {
        return Promise.reject('Path is not specified correctly in config ' + JSON.stringify(config));
      }

      var template = selectedTemplate || config.template;
      var params = {
        action: Action.CREATE_PAGE,
        path: path.parent,
        uid: path.name,
        template: template,
        language: config.language
      };

      return executeOperation(params)
        .then(function (response) {
          if ($element) {
            var detail = createDetail(null, config, 'content', response);
            util.emit(api.Event.ELEMENT_CREATED, detail, $element);
          }
          return response;
        });
    };


    var createSectionParams = function (action, previewId, config, template) {
      var params = {
        action: action,
        previewId: previewId,
        template: template || config.template,
        sectionName: config.sectionName,
        position: config.position,
        body: config.body || null
      };
      if (typeof(config.positionIndex) !== 'undefined') {
        params.positionIndex = ''+config.positionIndex;
        params.position = 'INDEX';
      }
      return params;
    };


    /**
     * @public
     * @since 1.0.0
     * @typedef {Object} TppCreateChildSectionConfig
     * @property {string} body - Name of the body to create the section in.
     * @property {string} [sectionName] - Name the created section should get. Default value is the uid of the used template.
     * @property {string} [template] - Uid of the section template to be used. If not given the CC template chooser dialog will be shown.
     * @property {TPP_API.SectionPosition} [position] - The position of the new child section.
     * @property {Number} [positionIndex] - If SectionPosition.INDEX was chosen, this gives the index of the newly created Section.
     */
    /**
     * Creates a child section for the page specified by the provided previewId.
     *
     * @name TPP_API.Operation.createChildSection
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.ELEMENT_CREATED on the $element.
     * @fires TPP_API.Event.CHILD_SECTION_CREATED on all elements specified by config.previewId.
     * @param {string} previewId - Referencing the page to create a child for.
     * @param {HTMLElement} [$element] - The related html element to fire the ELEMENT_CREATED event on.
     *      This can be a placeholder for the section to create.
     * @param {TppCreateChildSectionConfig} config - Config parameters for the creation of the section.
     * @param {string} [template] - When provided this overrides the template specified in the config
     * (this parameter can be used if the operation is used in a TppAction context).
     * @return {Promise}
     */
    operation.createChildSection = function (previewId, $element, config, template) {
      var params = createSectionParams(Action.CREATE_CHILD_SECTION, previewId, config, template);
      return executeOperation(params)
        .then(function (response) {
          util.previewElements()
            .filter(util.filter.byId(previewId))
            .forEach(function ($target) {
              var detail = createDetail(previewId, params, 'content', response);
              util.emit(api.Event.CHILD_SECTION_CREATED, detail, $target);
            });

          if ($element) {
            var detail = createDetail(null, config, 'content', response);
            util.emit(api.Event.ELEMENT_CREATED, detail, $element);
          }
        });
    };

    /**
     * @public
     * @since 1.0.0
     * @typedef {Object} TppCreateSiblingSectionConfig
     * @property {string} [sectionName] - Name the created section should get. Default value is the uid of the used template.
     * @property {string} [template] - Uid of the section template to be used. If not given the CC template chooser dialog will be shown.
     * @property {TPP_API.SectionPosition} [position] - The position of the new child section.
     * @property {Number} [positionIndex] - If SectionPosition.INDEX was chosen, this gives the index of the newly created Section.
     */
    /**
     * Creates a section relative to another section specified by its previewId.
     *
     * @name TPP_API.Operation.createSiblingSection
     * @public
     * @since 1.0.0
     * @fires TPP_API.Event.ELEMENT_CREATED on the $element.
     * @fires TPP_API.Event.SIBLING_SECTION_CREATED on elements matching the previewId.
     * @param {string} previewId - Referencing the section to create a sibling for.
     * @param {HTMLElement} [$element] - The related html element to fire the ELEMENT_CREATED event on.
     *    This can be a placeholder for the section to create.
     * @param {TppCreateSiblingSectionConfig} config - Configures the creation of the section.
     * @param {string} [template] - Override the template specified in the config.
     * @return {Promise}
     */
    operation.createSiblingSection = function (previewId, $element, config, template) {
      var params = createSectionParams(Action.CREATE_SIBLING_SECTION, previewId, config, template);
      return executeOperation(params)
        .then(function (response) {
          util.previewElements()
            .filter(util.filter.byId(previewId))
            .forEach(function ($target) {
              var detail = createDetail(previewId, params, 'content', response);
              util.emit(api.Event.SIBLING_SECTION_CREATED, detail, $target);
            });

          if ($element) {
            var detail = createDetail(null, params, 'content', response);
            util.emit(api.Event.ELEMENT_CREATED, detail, $element);
          }
        });
    };


    /**
     * @protected
     * @typedef {Object} TppCreateDatasetConfig
     * @property {string} template
     * @property {string} language
     */
    /**
     * Create a new Dataset.
     *
     * @name TPP_API.Operation.createDataset
     * @public
     * @since 1.2.0
     * @fires TPP_API.Event.ELEMENT_CREATED
     * @param {HTMLElement} [$element] - The related element to fire the event on
     * @param {TppCreateDatasetConfig} config - Configures the creation of the dataset
     * @return {Promise}
     */
    operation.createDataset = function ($element, config) {
      var params = {
        action: Action.CREATE_DATASET,
        template: config.template,
        language: config.language
      };

      return executeOperation(params)
        .then(function (response) {
          if ($element) {
            var detail = createDetail(null, config, 'content', response);
            util.emit(api.Event.ELEMENT_CREATED, detail, $element);
          }
          return response;
        });
    };


    /**
     * @name TPP_API.Operation.cropImage
     * @public
     * @since 1.1.0
     * @param {string} previewId - PreviewId of a media element
     * @param {string | Array.<string>} resolution - a single ResolutionUID or a an array of ResolutionUIDs
     */
    operation.cropImage = function (previewId, resolution) {
      var params = {
        action: Action.CROP_IMAGE,
        previewId: previewId,
        resolution: resolution
      };
      return executeOperation(params)
        .then(function (response) {
          if (response) {
            util.previewElements()
              .filter(util.filter.byId(previewId))
              .forEach(function ($target) {
                var detail = createDetail(previewId, params, 'reference', response);
                util.emit(api.Event.IMAGE_CHANGED, detail, $target);
              });
          }
        })
    }


    /**
     * Toggles an element to be a bookmark (flagged as master) or not. Bookmarked elements will appear
     * in creation dialogs, like {@link TPP_API.Operation.createChildSection} or {@link TPP_API.Operation.createPage}.
     *
     * @name TPP_API.Operation.toggleBookmark
     * @public
     * @since 1.1.6
     * @param {string} previewId - The previewId of the store element.
     * @return {Promise} Boolean which indicates if the element is now bookmarked or not.
     */
    operation.toggleBookmark = function (previewId) {
      var params = {
        action: Action.TOGGLE_BOOKMARK,
        previewId: previewId
      };

      return executeOperation(params).then(function(response) {
      	// fires a StatusUpdate on registered DOM nodes via Operation.getElementStatus
      	api.Operation.getElementStatus(previewId);
      	return response;
      });
    };


    /**
     * Returns all project languages (abbreviations). The first language is always the master language.
     *
     * @name TPP_API.Operation.getLanguages
     * @public
     * @since 1.2.4
     * @return {Array.<string>} - list of languages
     */
    operation.getLanguages = function () {
      return _project.languages;
    };


    /**
     * Returns the "External Preview URL" as set in FirstSpirit.
     *
     * @name TPP_API.Operation.getPreviewUrl
     * @public
     * @since 1.2.4
     * @return {<string>} - the "External Preview URL"
     */
    operation.getPreviewUrl = function () {
      return _project.previewUrl;
    };


    /**
     * Shows the translation help dialogue.
     *
     * Returns the rendered content only if the current language is the same
     * as the given `target` language.
     *
     * @name TPP_API.Operation.showTranslationDialog
     * @public
     * @since 1.2.4
     * @fires TPP_API.Event.CONTENT_CHANGED
     * @param {string} previewId - a PreviewId of DataProvider
     * @param {string} source - the source language
     * @param {string} target - the target language
     * @return {Promise} The rendered content.
     */
    operation.showTranslationDialog = function (previewId, source, target) {

      var params = {
        action: Action.TRANSLATION,
        previewId: previewId,
        source: source,
        target: target
      };

      return executeOperation(params)
        .then(function (response) {
          if (response !== null) {
            // force refresh of preview element to reflect changed state
            api.Common.setPreviewElement();

            util.previewElements()
              .filter(util.filter.byId(previewId))
              .forEach(function ($target) {
                var detail = createDetail(previewId, context, 'content', response);
                util.emit(api.Event.CONTENT_CHANGED, detail, $target);
              });
          }
          return response;
        });

    };


  }

  // noinspection JSUnusedLocalSymbols to provide same signature for each API component
  /**
   * This provides a UI to enrich html elements of the third party applications with a basic FirstSpirit style
   * interface. It draws an interactive border around elements and provides a UI element to work with the
   * {@link TPP_API.Operation}.
   *
   * @name TPP_API.Decorate
   * @public
   * @since 1.0.0
   */
  function Decorate(api, util, config) {
    var decorate = this;

    var initialized = false;

    var ensureInit = function () {

      if (!initialized) {
        initialized = true;
        // noinspection JSUndefinedPropertyAssignment
        document.head.appendChild(document.createElement('style')).innerHTML = [
          '.tpp-borders { position: fixed; z-index: 9999999999; opacity: 0; pointer-events: none; box-shadow: 0 0 3px rgba(0,0,0,.5), 0 0 3px rgba(0,0,0,.5) inset; border: 1px solid rgb(181,30,104); transition: opacity 300ms ease-in-out; }',
          '.tpp-buttons-container { position: fixed; display: none; pointer-events: all;}',
          '.tpp-buttons { position: absolute; top: 1px; right: 1px; background: linear-gradient(#626161, #424141); border: 1px solid #B5B5B5; display: inline-block; line-height: 23px; }',
          '.tpp-button { display: block; width: 23px; height: 23px; line-height: 23px; cursor: pointer; position: relative; float:left; text-align: center; }',
          '.tpp-button img {opacity: 0.7;}',
          '.tpp-button:hover img { opacity: 1; }',
          '.tpp-button.tpp-disabled { display : none; }',
          '.tpp-button.tpp-edit { background: linear-gradient(#A9356B, #79053B); }',
          '.tpp-workflow-flyout {font-family: Arial, Helvetica, sans-serif; font-size: 11px; overflow: hidden; cursor: pointer; color: lightgray; background: linear-gradient(#626161, #424141); position: absolute; top: 25px; width: 150px; height: 0px; transition: height .5s ease-out}',
          '.tpp-workflow-flyout li:hover {color:white;}',
          '.tpp-workflow-flyout.selected {height: auto;}',
          '.tpp-workflow-flyout.selected ul {max-height: 300px;}',
          '.tpp-workflow-flyout.selected ul:hover{ overflow-y: auto}',
          '.tpp-workflow-flyout.selected ul::-webkit-scrollbar{ width: 6px; background-color: transparent;}',
          '.tpp-workflow-flyout.selected ul::-webkit-scrollbar-track{ background-color: transparent;}',
          '.tpp-workflow-flyout.selected ul::-webkit-scrollbar-thumb{ background-color: #B4B4B4;}',
          '.tpp-workflow-flyout.selected ul::-webkit-scrollbar-thumb:hover{ background-color: lightgray;}',
          '.tpp-workflow-flyout ul {padding-left: 10px; transition: max-height .5s; max-height: 0; overflow-y: hidden}',
          '.tpp-workflow-flyout li {padding: 5px; display: block;}',
          '.tpp-workflow-flyout li:before {content: "\\00BB";}',
          '.tpp-workflow-grouptitle {font-weight: bold; padding: 5px; color: black; background-color: lightgray; margin-bottom: 8px;}'

        ].join('');
      }
    };


    var createActionBuilder = util.Types.createActionBuilder;


    /**
     * @protected
     * @name ActionStore.CUSTOM
     * @type {TppActionBuilder}
     */
    ActionStore.CUSTOM = createActionBuilder();

    /**
     * @protected
     * @name ActionStore.CREATE_PAGE
     * @type {TppActionBuilder}
     */
    ActionStore.CREATE_PAGE = createActionBuilder()
      .name('create')
      .label('Create a Page')
      .icon(api.Icon.CREATE_PAGE)
      .isEnabled(function (action) {
        return !action.getStatus().id;
      })
      .execute(function (action, args) {
        var selectedTemplate = (args.length > 0) ? args[0] : null;
        return api.Operation.createPage(action.getElement(), action.getContext(), selectedTemplate);
      });


    //This should be used to create a section to given page.
    //This can be attaches
    ActionStore.CREATE_CHILD_SECTION = createActionBuilder()
      .name('create_child_section')
      .label('Create a Section')
      .icon(api.Icon.CREATE_SECTION)
      .isEnabled(function (action) {
        return action.getStatus("elementType") === "Page" || action.getStatus("elementType") === "Body";
      })
      .execute(function (action, args) {
        var selectedTemplate = (args.length > 0) ? args[0] : null;
        var context = Object.assign({}, action.getContext(), {previewId: action.getPreviewId()});
        return api.Operation.createChildSection(action.getPreviewId(), action.getElement(), context, selectedTemplate);
      });

    //This should be used to create a section as a sibling
    //The can be attached as a button to every section of a listing
    ActionStore.CREATE_SIBLING_SECTION = createActionBuilder()
      .name('create_sibling_section')
      .label('Create a Sibling-Section')
      .icon(api.Icon.CREATE_SECTION)
      .isEnabled(function (action) {
        return action.getStatus("elementType") === "Section";
      })
      .execute(function (action, args) {
        var selectedTemplate = (args.length > 0) ? args[0] : null;
        var context = Object.assign({}, action.getContext(), {previewId: action.getPreviewId()});
        return api.Operation.createSiblingSection(action.getPreviewId(), action.getElement(), context, selectedTemplate);
      });

    /**
     * @protected
     * @name ActionStore.DEBUG_STATUS
     * @type {TppActionBuilder}
     */
    ActionStore.DEBUG_STATUS = createActionBuilder()
      .name('debugStatus')
      .label('Turn on Debug-Mode')
      .icon(api.Icon.DEBUG)
      .isEnabled(util.log.isEnabled)
      .execute(function (action) {
        var previewId = action.getPreviewId();
        api.Operation.getElementStatus(previewId).then(function (status) {
          util.log("Status received", previewId, status);
        });
      });


    /**
     * @protected
     * @name ActionStore.DEBUG_STATUS
     * @type {TppActionBuilder}
     */
    ActionStore.EDIT_ELEMENT = createActionBuilder()
      .name('edit')
      .label('Edit this Element')
      .icon(api.Icon.EDIT)
      .isEnabled(function (action) {
        return action.getStatus("permissions.change") &&
          action.getStatus("elementType") !== "Body" &&
          action.getStatus("elementType") !== "Media";
      })
      .execute(function (action) {
        return api.Operation.showEditDialog(action.getPreviewId());
      });


    /**
     * @protected
     * @name ActionStore.DEBUG_STATUS
     * @type {TppActionBuilder}
     */
    ActionStore.EDIT_META_DATA = createActionBuilder()
      .name('editMetaData')
      .label('Edit Meta Data')
      .icon(api.Icon.EDIT_META_DATA)
      .isEnabled(function (action) {
        return action.getStatus("permissions.changeMeta");
      })
      .execute(function (action) {
        return api.Operation.showMetaDataDialog(action.getPreviewId());
      });


    /**
     * @protected
     * @name ActionStore.DELETE_SECTION
     * @type {TppActionBuilder}
     */
    ActionStore.DELETE_SECTION = createActionBuilder()
      .name('deleteSection')
      .label('Delete this Section')
      .icon(api.Icon.DELETE)
      .isEnabled(function (action) {
        return action.getStatus().elementType === "Section"
          && action.getStatus("permissions.delete");
      })
      .execute(function (action) {
        return api.Operation.deleteSection(action.getPreviewId());
      });

    ActionStore.DELETE_PAGE = createActionBuilder()
      .name('deletePage')
      .label('Delete this Page')
      .icon(api.Icon.DELETE)
      .isEnabled(function (action) {
        return action.getStatus().elementType === "Page"
          && (action.getStatus().workflows.deleteWorkflow !== null || config.deletePageWorkflow !== null) && action.getStatus().workflows.current === null
      })
      .execute(function (action) {
        return api.Operation.deletePage(action.getPreviewId(), getDeleteWorkflowUID(action.getStatus()), action.getContext())
      });

    var getDeleteWorkflowUID = function (status) {
      if (config.deletePageWorkflow !== null) {
        return config.deletePageWorkflow;
      } else if (status.workflows.deleteWorkflow !== null) {
        return status.workflows.deleteWorkflow.uid;
      }
      return null;
    };

    /**
     * @protected
     * @name ActionStore.START_WORKFLOW
     * @type {TppActionBuilder}
     */
    ActionStore.START_WORKFLOW = createActionBuilder()
      .name('startWorkflow')
      .label('Start a Workflow:')
      .icon(api.Icon.WORKFLOW)
      .isEnabled(function (action) {
        return action.getStatus("elementType") !== "Body"
          && action.getStatus("elementType") !== "Media"
          && action.getStatus().workflows
          && action.getStatus().workflows.allowed
          && action.getStatus().workflows.allowed.length > 0;
      })
      .getOptions(function (action) {
        var _status = action.getStatus(), _workflows = _status.workflows;
        if (_workflows && _workflows.allowed) {
          var workflows = _workflows.allowed;

          if (_status.storeType === 'PAGESTORE' || _status.storeType === 'SITESTORE') {
            if (config.deletePageWorkflow !== null) {
              workflows = workflows.filter(function(workflow) {
                return workflow.uid !== config.deletePageWorkflow;
              });
            } else if (_workflows.deleteWorkflow !== null) {
              workflows = workflows.filter(function(workflow) {
                return workflow.id !== _workflows.deleteWorkflow.id;
              });
            }
          }

          return workflows.map(function(workflow) {
            return { id: workflow.id, label: workflow.displayName };
          });
        } else {
          return [];
        }
      })
      .execute(function (action, args) {
        var id = args[0];
        return api.Operation.startWorkflow(action.getPreviewId(), id);
      });

    /**
     * @protected
     * @name ActionStore.PROCESS_WORKFLOW
     * @type {TppActionBuilder}
     */
    ActionStore.PROCESS_WORKFLOW = createActionBuilder()
      .name('processWorkflow')
      .label('Process Workflow:')
      .isEnabled(function (action) {
        return action.getStatus("elementType") !== "Body"
          && action.getStatus("elementType") !== "Media"
          && action.getStatus().workflows && action.getStatus().workflows.current;
      })
      .getOptions(function (action) {
        if (action.getStatus().workflows && action.getStatus().workflows.transitions) {
          return action.getStatus().workflows.transitions.map(function (transition) {
            var displayName = transition.displayName;
            if (transition.target && transition.target.displayName) {
              displayName = transition.target.displayName;
            }
            return {id: transition.id, label: displayName};
          });
        } else {
          return [];
        }
      })
      .execute(function (action, args) {
        var id = args[0];
        return api.Operation.processWorkflow(action.getPreviewId(), id);
      });

    /**
     * @protected
     * @name ActionStore.CROP_IMAGE
     * @type {TppActionBuilder}
     */
    ActionStore.CROP_IMAGE = createActionBuilder()
      .name('cropImage')
      .label('Crop image')
      .icon(api.Icon.CROP_IMAGE)
      .isEnabled(function (action) {
        return action.getStatus("elementType") === 'Media'
          && action.getStatus("permissions.change");
      })
      .execute(function (action) {
        var resolution = action.getContext('imageResolution') || action.getContext('imageResolutions') || 'ORIGINAL';
        var resolutions = typeof(resolution) === 'string' ? resolution.split(/\s*,\s*/) : resolution;
        var previewId = action.getPreviewId();
        return api.Operation.cropImage(previewId, resolutions);
      });

    /**
     * @protected
     * @name ActionStore.ADD_BOOKMARK
     * @type {TppActionBuilder}
     */
    ActionStore.ADD_BOOKMARK = createActionBuilder()
      .name('addBookmark')
      .label('Add bookmark')
      .icon(api.Icon.ADD_BOOKMARK)
      .isEnabled(function (action) {
        return ['Section', 'Page', 'PageRef'].indexOf(action.getStatus('elementType')) !== -1 && !action.getStatus('bookmark');
      })
      .execute(function (action) {
        var previewId = action.getPreviewId();
        return api.Operation.toggleBookmark(previewId);
      });

    /**
     * @protected
     * @name ActionStore.DELETE_BOOKMARK
     * @type {TppActionBuilder}
     */
    ActionStore.DELETE_BOOKMARK = createActionBuilder()
      .name('deleteBookmark')
      .label('Delete bookmark')
      .icon(api.Icon.DELETE_BOOKMARK)
      .isEnabled(function (action) {
        return ['Section', 'Page', 'PageRef'].indexOf(action.getStatus('elementType')) !== -1 && action.getStatus('bookmark');
      })
      .execute(function (action) {
        var previewId = action.getPreviewId();
        return api.Operation.toggleBookmark(previewId);
      });


      /**
       * @protected
       * @name ActionStore.TRANSLATE
       * @type {TppActionBuilder}
       */
      ActionStore.TRANSLATE = createActionBuilder()
        .name('translate')
        .label('Translate')
        .icon(api.Icon.TRANSLATE)
        .isEnabled(function (action) {
          return ['Section', 'Page'].indexOf(action.getStatus('elementType')) !== -1 && api.Operation.getLanguages().length > 1;
        })
        .getOptions(function (action) {
          var languages = api.Operation.getLanguages();
          var options = [];

          for (var i=0, ln=languages.length; i<ln; i++) {
            for (var j=0; j<ln; j++) {
              if (i !== j) {
                options.push({ id: [languages[i], languages[j]], label: languages[i] + ' → ' + languages[j] });
              }
            }
          }

          return options;
        })
        .execute(function (action, args) {
          return api.Operation.showTranslationDialog(action.getPreviewId(), args[0][0], args[0][1]);
        });


    /** @type {[TppActionBuilder]}*/
    var INITIAL_DEFAULT_DECORATION_ACTIONS = [
      ActionStore.DEBUG_STATUS,
      ActionStore.EDIT_ELEMENT,
      ActionStore.CREATE_CHILD_SECTION,
      ActionStore.DELETE_SECTION,
      ActionStore.DELETE_PAGE,
      ActionStore.START_WORKFLOW,
      ActionStore.PROCESS_WORKFLOW
    ];


    var defaultDecorationActions = INITIAL_DEFAULT_DECORATION_ACTIONS;


    /**
     * Set the list of default buttons added to every decorated element.
     *
     * This does not mean that each of this buttons will be enabled.
     * Each button handle its visibility on its own. ({@link TppActionBuilder#isEnabled})
     *
     * This configuration is global, and should be set only once before decorating all elements.
     *
     * The initial list of default buttons is:
     *     TPP_API.Button.DEBUG_STATUS,
     *     TPP_API.Button.EDIT_ELEMENT,
     *     TPP_API.Button.DELETE_SECTION,
     *     TPP_API.Button.DELETE_PAGE,
     *     TPP_API.Button.START_WORKFLOW,
     *     TPP_API.Button.PROCESS_WORKFLOW
     *

     * @name TPP_API.Decorate.setDefaultButtons
     * @public
     * @since 1.1.2
     * @param {[TppActionBuilder]} buttons.
     * @example
     *  // Example 1
     *  // Workflows only accessible via ContentCreator menu bar,
     *  // and every decorated Image has an additional crop button.
     *  TPP_API.Decorate.setDefaultButtons([
     *         TPP_API.Button.DEBUG_STATUS,
     *         TPP_API.Button.EDIT_ELEMENT,
     *         TPP_API.Button.DELETE_SECTION,
     *         TPP_API.Button.DELETE_PAGE,
     *         TPP_API.Button.CROP_IMAGE
     *     ])
     *
     *  // Example 2
     *  // No default buttons set.
     *  // Add buttons on each element individually
     *  TPP_API.Decorate.setDefaultButtons([]);
     *  TPP_API.Decorate.element($el).addButton(TPP_API.Button.EDIT_ELEMENT);
     *  TPP_API.Decorate.element($img).addButton(TPP_API.Button.CROP_IMAGE);
     *  ...
     */
    decorate.setDefaultButtons = function (buttons) {
      defaultDecorationActions = buttons || [];
    };


    /**
     * Scans the entire document (or from a given $root) for elements with a data-preview-id attribute.
     *
     * It activates a UI for each of these elements with a mouse-over border and buttons in a
     * ContentCreator like manner.
     *
     * @name TPP_API.Decorate.scan
     * @public
     * @since 1.0.0
     * @param {HTMLElement} [$root=document] - An optional root to perform the search from.
     */
    decorate.scan = function ($root) {
      util.previewElements($root)
        .forEach(function ($el) {
          util.log('[scan] found', $el);
          decorate.element($el, $el.dataset.previewId);
        });
    };


    /**
     * @protected
     * @param {HTMLElement} $el
     * @param {string} previewId
     * @return {string}
     */
    var initPreviewId = function ($el, previewId) {
      previewId = previewId || $el.dataset.previewId;
      if (previewId) {
        $el.dataset.previewId = previewId;
      }
      return previewId;
    };

    /**
     * Initialize context values that could be given
     * via data-tpp-context-* fields on the given element.
     * @protected
     * @param $el
     * @param context {object}
     * @return {object}
     */
    var initContext = function ($el, context) {
      var contextFromAttributes = Object.keys($el.dataset)
        .filter(function (key) { return key.startsWith('tppContext'); })
        .reduce(function (object, key) {
          var name = key.substr('tppContext'.length);
          name = name[0].toLowerCase() + name.slice(1);
          object[name] = $el.dataset[key];
          return object;
        }, {});
      return Object.assign({}, contextFromAttributes, context);
    };

    /**
     * @protected
     * @param {TppButtonDecorator} buttons
     * @param {HTMLElement} $el
     * @param {string} previewId
     * @param {[TppActionBuilder]} customActions
     * @param {object} context
     * @return {void}
     */
    var updateDecoration = function (buttons, $el, previewId, customActions, context) {
      buttons.clearButtons();
      if (previewId) {
        defaultDecorationActions.forEach(function (builder) {
          buttons.addButton(builder
                              .previewId(previewId)
                              .element($el)
                              .updateContext(context));
        });
        customActions.forEach(function (builder) {
          buttons.addButton(builder
                              .previewId(previewId)
                              .element($el)
                              .updateContext(context));
          buttons.updateButtons({})
        });
        //initial status
        // noinspection JSIgnoredPromiseFromCall
        api.Operation.getElementStatus(previewId);
      } else {
        customActions.forEach(function (builder) {
          buttons.addButton(builder
                              .element($el)
                              .updateContext(context));
          buttons.updateButtons({})
        });
      }
    };

    /**
     * Creates a blank TppActionBuilder.
     *
     * @name TPP_API.Decorate.createActionBuilder
     * @return {TppActionBuilder}
     */
    decorate.createActionBuilder = util.Types.createActionBuilder;

    /**
     * Decorates a single element with a ContentCreator like UI.
     *
     * The UI provides an interactive border and a set of standard buttons.
     *
     * The previewId has either been annotated as a data-preview-id at this element, or can be given
     * as a second parameter. In the latter case the attribute will be set by this function. The parameter
     * takes precedence over the annotated 'data-preview-id' element.
     *
     * The context value can be uses to add context values to button. The context values will be merged using
     * {@link TppActionBuilder#updateContext}. The context values can also be given as data-tpp-* attributes.
     * Currently supported attributes are
     *
     * If no previewId is given, a decoration will be created with less functionality.
     * To give a previewId later on use {@link TppDecorator.updatePreviewId}.
     *
     *
     * @name TPP_API.Decorate.element
     * @public
     * @since 1.0.0
     * @param {HTMLElement} $el -  The element to decorate.
     * @param {string} [previewId] - The previewId assigned for the given element.
     * @param {object} [context] - Context value that are assigned to every button.
     * @return {TppDecorator} For adding custom functions.
     */
    decorate.element = function ($el, previewId, context) {

      ensureInit();

      /** @type {string} */
      var _previewId = initPreviewId($el, previewId);

      /** @type {object} */
      var _context = initContext($el);

      /** @type {[TppActionBuilder]} */
      var _customActions = [];

      var frameDecorator = util.ui.renderFrame($el);

      /** @type {TppButtonDecorator} */
      var buttons = util.ui.renderButtons(frameDecorator.getButtonContainer());

      // Listen for element deletion to remove also the borders
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var nodes = Array.from(mutation.removedNodes);
          var directMatch = nodes.indexOf($el) > -1;
          var parentMatch = nodes.some(function (parent) {return parent.contains($el);});
          if (directMatch || parentMatch) {
            frameDecorator.disposeBorders();
          }
        });
      });
      observer.observe(document.body, {
        subtree: true,
        childList: true
      });

      $el.addEventListener(api.Event.STATUS_CHANGED, function (event) {
        if (_previewId && _previewId === event.detail.previewId) {
          buttons.updateButtons(event.detail.status);
        }
      });

      var _updateDecoration = function () {
        updateDecoration(buttons, $el, _previewId, _customActions, _context);
      };

      _updateDecoration();

      /**
       * Fluent API to interact with the created decoration.
       * It can be used to create user defined actions and give and update the corresponding previewId.
       *
       * @class
       * @public
       * @since 1.0.0
       * @name TppDecorator
       * @typedef {TppDecorator}
       */
      /**
       * @type {TppDecorator}
       */
      var decorator = {
        /**
         * Adds a user defined button as an action builder to the elements UI.
         *
         * The action builder ({@link TppActionBuilder}) is used to create action instances ({@link TppAction})
         * and render the buttons accordingly.
         *
         * The visibility of the button depends on the {@link TppActionBuilder#isEnabled} callback.
         *
         * Note that the methods {@link TppActionBuilder#previewId} and {@link TppActionBuilder#element}
         * will be called internally by the decorator. So the resulting action has access to this information
         * if available. You can access {@link TppAction#getPreviewId} and {@link TppAction#getElement} in
         * the callbacks given to the action builder. This can be seen in the following example.
         * Therefore the configured action is neither node- nor previewId-specific and
         * can be reused for more than one element decoration.
         *
         * If the element is connected to FirstSpirit content by previewId, the {@link TppAction#getStatus} gives
         * access to the current status of the content.
         *
         * The button can either be configured completely from scratch by using an empty action builder
         * as in the following example -
         * Or by configuring one of the predefined buttons under {@link TPP_API.Button}. See more examples there.
         *
         * @example
         * const $el_A = ... ,$el_B = ... // Some divs containing an image
         * const cropImage = TPP_API.Decorate.createActionBuilder();
         *
         * // 1. configure an crop image button
         * cropImage
         *    .name('cropImage')
         *    .label('Crop image')
         *    .context({
         *      minWidth: 200,
         *      imageSelector : 'div>img.avatar'
         *     })
         *    .isEnabled((action)=>{
         *        return action.getStatus('permissions.change')
         *    })
         *    .execute((action)=>{
         *
         *        const params = {
         *          previewId: action.getPreviewId(),
         *          context: action.getContext()
         *        }
         *
         *        TPP_API.Common
         *          .execute('class:CropImage', params)
         *          .then((result)=>{
         *              MyApp.refreshElement(action.getElement(), result);
         *          });
         *    });
         *
         *
         * TPP_API.Decorate.element($el_A)   // 2. Decorate the element
         *       // 3a. Add the element
         *       .addButton( cropImage )
         *
         *       // 3b. Alternative way to start with a blank action builder
         *       .addButton(TPP_API.Button.CUSTOM.name('blurImage'). ... )
         *
         *       // 3c. It's also possible to give a callback
         *       // that takes a blank action builder as parameter
         *       // and returns a configured action builder
         *       .addButton( builder => { return builder.name('rotateImage'). ... } );
         *
         *
         * // 4. Reuse the action builder to decorate another element
         * TPP_API.Decorate.element($el_B).addButton( cropImage );
         *
         *
         *
         * @public
         * @since 1.0.0
         * @name TppDecorator.addButton
         * @param {TppActionBuilder|TppActionBuilderCallback} actionSpec
         * @return {TppDecorator}
         */
        addButton: function (actionSpec) {
          var actionBuilder = util.Types.actionHelper.actionSpecToBuilder(actionSpec);
          if (actionBuilder) {
            _customActions.push(actionBuilder);
            _updateDecoration();
          } else {
            util.log('actionSpec has to be of type TppActionBuilder');
          }
          return decorator;
        },


        /**
         * Enrich the given decoration by a new previewId.
         *
         * This will trigger a refresh of all attached actions and fetch a new status for the given previewId.
         * See {@link TppAction#getStatus} and {@link TPP_API.Operation.getElementStatus} for more information
         *
         *
         *
         * @public
         * @since 1.0.0
         * @name TppDecorator.updatePreviewId
         * @param {string} previewId
         * @return {TppDecorator}
         */
        updatePreviewId: function (previewId) {
          _previewId = previewId;
          $el.dataset.previewId = previewId;
          _updateDecoration();
          return decorator;
        }
      };
      return decorator;
    };
  }

  /**
   * Utilities for debugging, testing and support.
   * This not a stable API!!
   *
   * @protected
   * @param api
   * @param util
   * @param config
   * @constructor
   */
  function Debug(api, util, config) {
    var debug = this;

    debug.currentConfig = Object.assign({}, config);
    debug.defaultConfig = Object.assign({}, DEFAULT_CONFIG);

    debug.enableDebugLog = api.enableDebugLog;

    debug.parsePreviewId = function (previewId) {
      if (typeof previewId === 'string') {
        try {
          var raw = JSON.parse(atob(previewId));
          var result = {};
          ['data-fs-id', 'data-fs-attrs'].forEach(function (prop) {
            var rawProp = raw[prop];
            try {
              result[prop] = JSON.parse(atob(rawProp));
            } catch (e) {
              //ignore
            }
          });

          return result;
        } catch (e) {
          // console.error(previewId,e);
          return null;
        }
      }
      return null;
    };

    debug.apiInitialized = false;

    debug.version = FRONTEND_VERSION;
    debug.gitHash = GIT_HASH;

    debug.getInfo = function () {
      return {
        version: debug.version,
        gitHash: debug.gitHash,
        config: debug.currentConfig
      }
    };

    /**
     * Check version of backend and frontend.
     * Can be used to check communication with backend.
     * It will log information to the console.
     *
     * @name TPP_API.Debug.checkVersions
     * @param {Number} [timeout=5000] - Timeout to wait for the backend.
     * @return {Promise} - Promise resolves to an object with version info.
     *  Will be rejected if no connection to backend could be established.
     */
    debug.checkVersions = function (timeout) {
      if (typeof timeout === 'undefined') {
        timeout = 5000;
      }

      var pingBackend = function () {
        return new Promise(function (resolve, reject) {
          util.messageService.send({tpp: {ping: true, version: FRONTEND_VERSION}}, config.origin, resolve);
          setTimeout(function () {
            var message = "No Response from Backend. Timeout [" + timeout + "ms]";
            reject(message)
          }, timeout);
        });
      };

      var mapResult = function (result) {
        return {
          backendVersion: result.version,
          frontendVersion: FRONTEND_VERSION
        };
      };

      var checkMissmatch = function (result) {
        result['missmatch'] = (result.backendVersion !== result.frontendVersion);
        return result;
      };

      return pingBackend()
        .then(mapResult)
        .then(checkMissmatch);
    }

  }


  /**
   * The global object or initial entry point to access the TPP_API.
   * You need to initialize the API using {@link TPP_API.init}.
   *
   * @name TPP_API
   * @public
   * @since 1.0.0
   *
   * @example
   * // Include the script
   * <script src="$PATH_TO_MODULE$/lib/fs-tpp-api.js" data-tpp-init></script>
   *
   * // Alternatively you can use e.g. [unpkg.com](https://unpkg.com) with an appropriate version specifier:
   * <script src="https://unpkg.com/fs-tpp-api@1.2.0/fs-tpp-api.js" data-tpp-init></script>
   *
   * // ES6 import
   * import TPP_API from 'fs-tpp-api';
   *
   * // Node
   * const TPP_API = require('fs-tpp-api');
   */
  var TPP_API = function () {
    var api = {};

    api.Event = {

      /**
       * @private
       * @event TPP_API.Event.INIT
       */
      INIT: 'tpp-init',

      /**
       * @event TPP_API.Event.CONTENT_CHANGED
       * @public
       * @since 1.0.0
       * @property {string} previewId
       * @property {any} context
       * @property {string} content
       */
      CONTENT_CHANGED: 'tpp-content-changed',


      /**
       * @event TPP_API.Event.IMAGE_CHANGED
       * @public
       * @since 1.1.0
       * @property {string} previewId
       * @property {any} context
       * @property {string} reference
       */
      IMAGE_CHANGED: 'tpp-image-changed',

      /**
       * Fired when the status of the store element has changed.
       *
       * @event TPP_API.Event.STATUS_CHANGED
       * @public
       * @since 1.0.0
       * @property {string} previewId
       * @property {any} context
       * @property {Object} status
       */
      STATUS_CHANGED: 'tpp-status-changed',

      /**
       * Fired when a workflow was started.
       *
       * This event is no longer used and is superseded by {@link TPP_API.Event.WORKFLOW_PROCESSED}.
       *
       * @event TPP_API.Event.WORKFLOW_STARTED
       * @public
       * @since 1.0.0
       * @deprecated since version 1.1.0
       * @property {string} previewId
       * @property {any} context
       * @property {string} workflowId
       */
      WORKFLOW_STARTED: 'tpp-wf-start',

      /**
       * Fired on every workflow step.
       *
       * @event TPP_API.Event.WORKFLOW_PROCESSED
       * @public
       * @since 1.0.0
       * @property {string} previewId
       * @property {any} context
       * @property {string} workflowId
       * @property {string} transitionId
       */
      WORKFLOW_PROCESSED: 'tpp-wf-process',

      /**
       * Fired when an element was deleted.
       *
       * @event TPP_API.Event.ELEMENT_DELETED
       * @public
       * @since 1.0.0
       * @property {string} previewId
       * @property {any} context
       * @property {boolean} deleted
       */
      ELEMENT_DELETED: 'tpp-element-deleted',


      /**
       * @event TPP_API.Event.CHILD_SECTION_CREATED
       * @public
       * @since 1.0.0
       * @property {string} previewId - the previewId of the parent page
       * @property {TppCreateChildSectionConfig} context - creation context
       * @property {any} content - the rendered content of the new section
       */
      CHILD_SECTION_CREATED: 'tpp-child-section-created',

      /**
       * @event TPP_API.Event.SIBLING_SECTION_CREATED
       * @public
       * @since 1.0.0
       * @property {string} previewId - the previewId of the sibling page
       * @property {TppCreateSiblingSectionConfig} context - creation context
       * @property {string} content - the rendered content of the new section
       */
      SIBLING_SECTION_CREATED: 'tpp-sibling-section-created',

      /**
       * Fired when a FirstSpirit element was created.
       *
       * This event is different from the other events, as it does not contain a previewId.
       * It is intended to be fired on a placeholder HTMLElement that stands for the newly created element.
       *
       * @event TPP_API.Event.ELEMENT_CREATED
       * @public
       * @since 1.0.0
       * @property {TppCreateChildSectionConfig|TppCreateSiblingSectionConfig} context - creation context
       * @property {any} content - the rendered content of the newly created element
       */
      ELEMENT_CREATED: 'tpp-element-created',


      /**
       * Fired when the outer content creator requests to show a certain element for example by clicking it in a report.
       *
       * @event TPP_API.Event.ELEMENT_REQUESTED
       * @public
       * @since 1.1.0
       * @property {string} previewId - the preview
       */
      ELEMENT_REQUESTED: 'tpp-element-requested',


      /**
       * Fired when there are changes in the SiteStore triggered in the outer ContentCreator.
       * Will be fired on document.body and on all elements annotated with the previewId (if one is set in the event).
       *
       * There are two cases in which this event is fired:
       *  * 1. A new PageRef was created, then the previewId parameter is not null and provides the
       *    previewId of this PageRef.
       *  * 2. The order of sitestore element has changed, then the previewId parameter is null.
       *
       *  In both cases the navigation has to be rebuild and newly interpreted in the third party app.
       *
       * @event TPP_API.Event.NAVIGATION_CHANGED
       * @public
       * @since 1.1.0
       * @property {string} [previewId] - If a new page ref is created the previewId of this PageRef will be send here.
       *                                   Otherwise this is null.
       */
      NAVIGATION_CHANGED: 'tpp-navigation-changed'

    };


    /**
     * String constants to define a child position.
     * Used in {@link TPP_API.Operation.createChildSection}.
     * @public
     * @since 1.0.0
     * @name TPP_API.SectionPosition
     * @enum {string}
     */
    api.SectionPosition = {
      /**
       * Insert at first position.
       * @name TPP_API.SectionPosition.FIRST
       * @public
       * @since 1.0.0
       * */
      FIRST: 'FIRST',
      /**
       * Insert at last position.
       * @name TPP_API.SectionPosition.LAST
       * @public
       * @since 1.0.0
       * */
      LAST: 'LAST',
      /**
       * Insert before specified sibling.
       * @name TPP_API.SectionPosition.BEFORE
       * @public
       * @since 1.0.0
       */
      BEFORE: 'BEFORE',
      /**
       * Insert after specified sibling.
       * @name TPP_API.SectionPosition.AFTER
       * @public
       * @since 1.0.0
       */
      AFTER: 'AFTER',
      /**
       * Insert at a specified index.
       * @name TPP_API.SectionPosition.INDEX
       * @public
       * @since 1.0.0
       */
      INDEX: 'INDEX'
    };


    /**
     * The WorkflowMode is used to set the main store object the workflow is executed on.
     *
     * This is needed to harmonise the behaviour of the tpp workflow buttons and
     * the buttons from the ContentEditor frame who triggers workflow actions.
     *
     * The mode is a global setting that will be given via {@link TPP_API.init}. The setting determines,
     * how the internal buttons behave. So you need to know, how the ContentCreator is configured in your project, to
     * configure the TPP_API accordingly.
     *
     * @public
     * @since 1.1.0
     * @name TPP_API.WorkflowMode
     * @enum {string}
     */
    api.WorkflowMode = {
      /**
       * @name TPP_API.WorkflowMode.PAGE_DRIVEN
       * @public
       * @since 1.1.0
       * The Workflow will be started on the current page object.
       */
      PAGE_DRIVE: 'PAGE_DRIVE',

      /**
       * The workflow will be started on the current pageref object.
       * @name TPP_API.WorkflowMode.PAGE_REF_DRIVEN
       * @public
       * @since 1.1.0
       */
      PAGE_REF_DRIVEN: 'PAGE_REF_DRIVE'
    }


    api.Icon = {
      /**
       * @name TPP_API.Icon.EDIT
       * @public
       * @since 1.0.0
       */
      EDIT: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTAw9HKhAAAAyElEQVQ4T9WU4QqDMBCDRRBBhiAiyBiMgY/pu9dEWnFSe7mfFkJRz880XltVjx8hhNUSFtlCtWuxFpTPAZwi3MWmG774KcgPhiN5uCKRqSj0RqJEkWLSI7Ecw+XAGsw91MndIYCnVAPoSwbHH1LqigMcnWtwwXF/rZGcC+A/x55YrK7Igs1YSluaHcFOyK0K93/QCDXZfW6A9749g3G9QF9otrIuRXGAAXmfgOxp88TjccgiNv9V6WXOjEUCZqO5ucmPM8vbM3kDZGPFNvxi+34AAAAASUVORK5CYII=",

      /**
       * @name TPP_API.Icon.EDIT_META_DATA
       * @public
       * @since 1.1.2
       */
      EDIT_META_DATA: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAAHjfs0eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpBOUQxQjhFMDAxNDhFMTExOTFGNDlEMUVCNkMxQkEwMCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyNzgyNTE4RjYxMUMxMUUxQThBRUE5MTJEMzMyRDY1OCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyNzgyNTE4RTYxMUMxMUUxQThBRUE5MTJEMzMyRDY1OCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNzdCMUY2OUUwNDhFMTExOTFGNDlEMUVCNkMxQkEwMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBOUQxQjhFMDAxNDhFMTExOTFGNDlEMUVCNkMxQkEwMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlzLg4kAAADDSURBVHjaYvz//z8DDDAxIAEUDkAAMRKnDCCAkJXBGIwgggVJURaSAkaAAEIxGAZY0IwAG8OEZB4juspMJJX/0c0EWwQQQFgtwgVY0PjYdDLiUpyFxp8GcwJGQGIBKF5mIeBMRmQOQACR5EEmBhIAC7EhQZHJjKQozkSTm44cxsQ64z+xQYczKTNQNTQAAoykGCQ3mAkla4JeItt71HAx2S4lZHAWCemFkdqR9x+fL3C5OJOAodMJ+YBaLmakVuQRjEAA4Ow5e6ANBqwAAAAASUVORK5CYII=",

      /**
       * @name TPP_API.Icon.DELETE
       * @public
       * @since 1.0.0
       */
      DELETE: "data:image/png;base64,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",
      /**
       * @name TPP_API.Icon.GROUPACTION
       * @public
       * @since 1.0.0
       */
      GROUPACTION: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAAGXljaGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQkNGMTk4RTlCMjExRTBCQTc4Q0QxRkI0ODk1RjA0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjVFQkNGMTk5RTlCMjExRTBCQTc4Q0QxRkI0ODk1RjA0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NUVCQ0YxOTZFOUIyMTFFMEJBNzhDRDFGQjQ4OTVGMDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NUVCQ0YxOTdFOUIyMTFFMEJBNzhDRDFGQjQ4OTVGMDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4j+SC7AAAApklEQVR42mL8//8/AwgwMUABQAAxAEX+Mz1+/JgBIIAYQXKfP38GKwAIIEYUhSBRuAhAAMEZv3//BjNYWVkZ4ea9f/8ejEEAIIBgKkEEI9wwoDa4VhYQ8ePHDwYo/R+s4vv372DMy8sLMfjnz58MYmJiYDMAAgxuPQj8+/cPzmFiYmKEsVkYkABINxIAa+Dk5GREUQSyDx0AFaGaBHMpCEhJScGtAwDOn1MNwUTjlwAAAABJRU5ErkJggg==",
      /**
       * @name TPP_API.Icon.DEBUG
       * @public
       * @since 1.0.0
       */
      DEBUG: "data:image/png;base64,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",
      /**
       * @name TPP_API.Icon.WORKFLOW
       * @public
       * @since 1.0.0
       */
      WORKFLOW: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE1MUVCNzBCMDE0NDExRTE4MTIwREU0NEQzOTMzM0Y4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE1MUVCNzBDMDE0NDExRTE4MTIwREU0NEQzOTMzM0Y4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTUxRUI3MDkwMTQ0MTFFMTgxMjBERTQ0RDM5MzMzRjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTUxRUI3MEEwMTQ0MTFFMTgxMjBERTQ0RDM5MzMzRjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz65ABaxAAAAl0lEQVR42mL8//8/AwgwMUABQAAxYogABBBcBAhADEa4DIgDIgACCFkFWN9/ZA5cLxNMPYgGCCAUPcimI2v7j2YTmM+CLoAMAAIIm7EM2FyDbjyGJF6djLgk/+PS+R+JxggeRiQabjRAgOH1CnJooQMWfO5BE2fEpZEBi+nINqLYjjfscDkTXSMjthAiNkKItp2FFOchAwBEcygkEeR08gAAAABJRU5ErkJggg==",
      /**
       * @name TPP_API.Icon.CREATE_PAGE
       * @public
       * @since 1.0.0
       */
      CREATE_PAGE: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAAHjfs0eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdFMDhBMzA2NzI3ODExRTE5M0EzQTc5MUI3RjlEQzc2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdFMDhBMzA3NzI3ODExRTE5M0EzQTc5MUI3RjlEQzc2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0UwOEEzMDQ3Mjc4MTFFMTkzQTNBNzkxQjdGOURDNzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0UwOEEzMDU3Mjc4MTFFMTkzQTNBNzkxQjdGOURDNzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz67EEkXAAAAv0lEQVR42mL8//8/AwwwQen/yBxGkABAADESpYwBIICQlf1HlmBiQAWMMAUAAYRiMDYL/qMLYlWJAliQbYYBgADCahEuwILG/4/F+fjdQKzJjHhsYmQhYBiKZoAAIsmDZLv5PwH34zX5P0XOoJpiRnSnsBARIf9xJWVsocFIrJtRbAMIMJJikJJEhzM+8EUsKQYTCkiCFrCQ4DtGIn1EeiKiRhgTG+44g4WFRIOQU/h/fBawkBnzjJS4mNQIRQEAAoouSwxwE+wAAAAASUVORK5CYII=",
      /**
       * @name TPP_API.Icon.CREATE_SECTION
       * @public
       * @since 1.0.0
       */
      CREATE_SECTION: "data:image/png;base64,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",
      /**
       * @name TPP_API.Icon.CROP_IMAGE
       * @public
       * @since 1.1.0
       */
      CROP_IMAGE: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAABGdBTUEAAK/INwWK6QAAAAlwSFlzAAAOwgAADsIBFShKgAAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTAw9HKhAAAAgUlEQVQ4T2P4//8/Ay0wTQwFOXTQGRwJdNVMfEFIrosHr8FA3xINUHxPKChApk7BgncCxa6giZNlMLoDKA5jmItHqMGg8INhUFCAIgpZDMYmOYOANMAwyGBQ7COLIbNxpipikxshdRjyhDTgShWE9BEs3WhmMEGX4SrhyNZIqNYBAOWOEXeO7QWpAAAAAElFTkSuQmCC",
      /**
       * @name TPP_API.Icon.ADD_BOOKMARK
       * @public
       * @since 1.1.6
       */
      ADD_BOOKMARK: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAAHjfs0eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjI3N0ZBOUU5NjEzRTExRTJCNkRDODFGNjk4NDJCRDY3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjI3N0ZBOUVBNjEzRTExRTJCNkRDODFGNjk4NDJCRDY3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Mjc3RkE5RTc2MTNFMTFFMkI2REM4MUY2OTg0MkJENjciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Mjc3RkE5RTg2MTNFMTFFMkI2REM4MUY2OTg0MkJENjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7EpoHcAAABGElEQVR42mL4//8/AxBLgGhGEAEDTAxIACCAcMugcAACiAFqmtl/CIiB8uGqTgFxLLIGgABCMRjdTJDMXyCOQTabE4h1YeayQFUGQ+nLOM0ECCB0QSEgfgsSZ8AC0BXDOIuAeDeS+BIQwYKmORaLgUvw+hcXYGIgAQAEELrJbED8i1iTXwGxGU6jYaENxB/+I8A05BhGj2kQ8EFiH4PSMcgGIwfdU1yRgcuDMfjCmVDQLSGYCKkSKSQpBggwQs6oAGJdII5mIBFgM7gOiL2B2ATNlY+B+A4QLwPiH9gCC1fKQMZ+/zFBHQ61WDELDvv4gfgzEG8H4k9QH5jhSAtYXY4vjGOIDM4l5EQe2YASFy+hJLnRxMUUAQDIWuXpcvA6lwAAAABJRU5ErkJggg==",
      /**
       * @name TPP_API.Icon.DELETE_BOOKMARK
       * @public
       * @since 1.1.6
       */
      DELETE_BOOKMARK: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAAHjfs0eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjM3RDgzMUQ2NjEzRTExRTJBRTUzQTE0Qzg2NDBGMjZGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjM3RDgzMUQ3NjEzRTExRTJBRTUzQTE0Qzg2NDBGMjZGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzdEODMxRDQ2MTNFMTFFMkFFNTNBMTRDODY0MEYyNkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzdEODMxRDU2MTNFMTFFMkFFNTNBMTRDODY0MEYyNkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6VnafPAAABG0lEQVR42mL4//8/AxBLgGhGEAEDTAxIACCAcMugcAACiAFqmtl/CIiB8hlgEgxIgiDAABBAKAajmwmS+QvEMchmcwKxLsw4FqjKYCh9CeRWrGYCBBC6oBAQvwWJM2AB6IphnEVAvBtJfAmIYEHTHIvFwCW4TMYLmBhIAAABhG4yGxD/ItbkV0BshtNopMj78B8BpiHHMAwjm+yDxD4GpWOQDUYOuqe4IgOXB2PwhTO+oFsMxf9pHykkKQYIMELOqABiXSCOZiARYDO4Doi9gdgEzZWPgfgOEC8D4h/ooYovZSBjv/+YoA6HWqyYBYd9/ED8GYi3A/EnqA/McKQFrC7HF8YxRAbnEnIij2xAjouXIKduZLMG3MUUAQB/1/qqz56eugAAAABJRU5ErkJggg==",
      /**
       * @name TPP_API.Icon.TRANSLATE
       * @public
       * @since 1.2.4
       */
       TRANSLATE: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC41ZYUyZQAAAINJREFUOE+1kAEKgEAIBHtfnwr6uCXhsbetSWQLA96od9FiZr8gZQdSdiBlB1J2wGIHuJchd3DA4YEq2d7jr8DgWfVusMCXOei4Lr9YXbydRB/riNflxQjGz+tVTrUHdwYs+OUq2V568TREROIsd0bxAo/yE1J2IGUHUnYgZQdSfseWA4mZHgMwLO3eAAAAAElFTkSuQmCC"
    };

    return api;
  }();


  function initButtonConstants(api) {
    api.Button = {

      /**
       * A collection of predefined buttons.
       * @public
       * @since 1.0.0
       * @name TPP_API.Button
       */
      /**
       * Custom button.
       * @public
       * @since 1.0.0
       * @name TPP_API.Button.CUSTOM
       * @type {TppActionBuilder}
       * @example
       *
       * TPP_API.Decorate.element($el).addButton(
       *   TPP_API.Button.CUSTOM
       *      .context({content_spot: "banner"})
       *      .name("promote-banner")
       *      .label("Promote Banner")
       *      .context({
       *            type: "promote",
       *            content_spot: "banner"
       *        })
       *      .icon("/icons/promote.png")
       *      .isEnabled((action) =>
       *           !isBannerPromoted( action.getPreviewId(), action.getContext().content_spot )
       *      .execute((action) =>
       *          promoteBanner( action.getPreviewId(), action.getContext().content_spot )
       *        );
       *
       * TPP_API.Decorate.element($el).addButton(
       *   TPP_API.Button.CUSTOM
       *      .context({content_spot: "carousel"})
       *      .name("theme-switch")
       *      .options(
       *           (action) => {
       *              var options = [{id:"default", label:"Set default theme"}];
       *              if (contentSpotsSupportsTheme(action.getPreviewId(), "dark")) {
       *                 options.push({id:"dark", label:"Set dark theme"});
       *              }
       *              if (contentSpotsSupportsTheme(action.getPreviewId(), "light)) {
       *                 options.push({id:"light", label:"Set light theme"});
       *              }
       *              return options;
       *           }
       *        )
       *      .execute((action, args) =>
       *          var theme = args[0];
       *          setTheme(action.getPreviewId(), theme);
       *        );
       *
       *
       **/
      CUSTOM: ActionStore.CUSTOM,

      /**
       * @public
       * @since 1.0.0
       * @name TPP_API.Button.CREATE_PAGE
       * @example
       *
       * // Example A
       *
       * // 1. Create Placeholder
       * // In case you have no data for a current slot on your page, you can render an element $el as a placeholder
       * var $el = MyApp.createPlaceholder();
       *
       * // 2. Decorate it
       * // * $el will be decorated with a border
       * // * If $el has no data-preview-id attribute a CREATE_PAGE button will be rendered
       * // * This Button opens an editor form for a page based on 'template_uid'
       * // * If form is submitted
       * //  + a Page will be create in the PageStore under 'path/to/element' with the uid 'uid_of_element'
       * //  + a PageRef to this Page will be created in the SiteStore under 'path/to/element' with the uid 'uid_of_element'
       * //  + if successful an ELEMENT_CREATED event will be fired
       * var create = TPP_API.Button.CREATE_PAGE.context({
       *                                      template: 'template_uid',
       *                                      path: 'path/to/element/uid_of_element',
       *                                      language: 'en'})
       * var decorator = TPP_API.Decorate.element($el).addButton(create);
       *
       *
       * // 3. Wait for creation
       * $el.addEventListener(TPP_API.EVENT.ELEMENT_CREATED, function(e){
       *
       *    // 4. Fill your placeholder with real data
       *    var contentData = e.detail.content;
       *    $el.innerHTML = MyApp.render(contentData);
       *
       *    // 5. Update the decoration
       *    // This will update the elements decoration and enable all previewId related buttons.
       *    // (Currently the ELEMENT_CREATED event does not have a previewId property.
       *    // You have to know where you put it in your content and extract it by yourself.)
       *    var previewId = MyApp.extractPreviewId(contentData);
       *    decorator.updatePreviewId( previewId );
       *
       * });
       *
       *
       * // Example B
       *
       * // You can also add options to select the
       * var create = Decorate.CREATE_PAGE
       *                  .context({ path: 'path/to/element/uid_of_element', lang: 'en' })
       *                  .options([{id : 'template_uid_1', label : 'Basic'}, {id: 'template_uid_2', label: 'Advanced'}])
       *
       * var decorator = Decorate.element($el).addButton(create);
       *
       *
       */
      CREATE_PAGE: ActionStore.CREATE_PAGE,


      /**
       * This button can be used to decorate a page element. It creates child sections for this page element.
       * That means a new section will be added to the page within a given body/content area.
       *
       * The {@link TppActionBuilder#context} should be called with a parameter of type {@link TppCreateChildSectionConfig}.
       *
       * The section template can be selected in three different ways. Either by the standard ContentCreator dialog,
       * given as a fixed value, or with the TPP buttons drop down capability ({@link TppActionBuilder#options}).
       * See examples for more info about choosing the section template.
       *
       * To handle the creation of the section afterwards see {@link TPP_API.Event.CHILD_SECTION_CREATED} and
       * {@link TPP_API.Event.ELEMENT_CREATED}.
       *
       * @public
       * @since 1.0.0
       * @name TPP_API.Button.CREATE_CHILD_SECTION
       * @example
       *
       * // Assumption for every example:
       * // An html element representing the page is given.
       * // It is annotated with a data-preview-id of a page.
       * // The page element should not be the body element of the whole page even if only on FirstSpirit page is rendered
       * // as a whole page in the third party application.
       * // Instead it could be a title or header element.
       * var $pageElement = ...
       *
       *
       * // Example 1 - Simple case
       * // User is provided a dialog with all possible templates.
       * // At least the name of the body (content area) has to be specified.
       * // This dialog is a standard ContentCreator functionality.
       * // The name of the section will be derived from the uid of the selected template.
       * // The new section will be placed after the given section
       * TPP_API.Decorate.element($pageElement).addButton(Decorate.CREATE_CHILD_SECTION.context({body : "main"}));
       *
       * // Example 2 - Preselect the given template.
       * // The button can also be pre-configured to choose a specific section template.
       * TPP_API.Decorate
       *      .element($pageElement)
       *      .addButton(TPP_API.Button.CREATE_CHILD_SECTION.context(
       *        {
       *          body: "main",
       *          template : "section_template_uid"
       *        }
       *      ));
       *
       *
       * // Example 3 - Give a static list of templates.
       * // The section template can also be chosen from a fixed list of templates.
       * // There for the drop down capability of the TppButtons can be used.
       * TPP_API.Decorate
       *      .element($pageElement)
       *      .addButton(TPP_API.Button.CREATE_CHILD_SECTION
       *        .context(
       *          {
       *            body: "main",
       *            template : "section_template_uid"
       *          }
       *        )
       *        .options(
       *          [
       *          {id: 'section_template_uid_1', label : 'Basic Section'},
       *          {id: 'section_template_uid_2', label : 'Advanced Section'}
       *          ]
       *         }
       *      );
       *
       * // Example 4 - Position and section name
       * // The position and also the name of the new section can be set .
       * // (If there are collisions in the section names a suffix will be appended.)
       * // The object given to the context i
       * TPP_API.Decorate
       *      .element($pageElement)
       *      .addButton(TPP_API.Button.CREATE_CHILD_SECTION.context(
       *        {
       *          body: "left",
       *          template : "section_template_uid",
       *          position: TPP_API.SectionPosition.LAST,
       *          sectionName: "teaser_entry"
       *        }
       *      ));
       */
      CREATE_CHILD_SECTION: ActionStore.CREATE_CHILD_SECTION,


      /**
       * This button can be used to decorate a section. It creates siblings sections for it.
       * That means a new section will be added to the same body within the same page.
       *
       * The {@link TppActionBuilder#context} should be called with a parameter of type {@link TppCreateSiblingSectionConfig}.
       *
       * The section template can be selected in three different ways. Either by the standard ContentCreator dialog,
       * given as a fixed value, or with the TPP buttons drop down capability ({@link TppActionBuilder#options}).
       * See examples for more info about choosing the section template.
       *
       * To handle the creation of the section afterwards see {@link TPP_API.Event.SIBLING_SECTION_CREATED} and
       * {@link TPP_API.Event.ELEMENT_CREATED}.
       *
       * @public
       * @since 1.0.0
       * @name TPP_API.Button.CREATE_SIBLING_SECTION
       * @example
       *
       * //In every example $section is an html element annotated with the data-preview-id of a section.
       *
       * // Example 1 - Simple case
       * // User is provided a dialog with all possible templates.
       * // This dialog is a standard ContentCreator functionality.
       * // The name of the section will be derived from the uid of the selected template.
       * // The new section will be placed after the given section
       * TPP_API.Decorate
       *      .element($section)
       *      .addButton(TPP_API.Button.CREATE_SIBLING_SECTION);
       *
       *
       * // Example 2 - Preselect the given template.
       * // The button can also be pre-configured to choose a specific section template.
       * TPP_API.Decorate
       *      .element($section)
       *      .addButton(TPP_API.Button.CREATE_SIBLING_SECTION.context(
       *        { template : "section_template_uid" }
       *      ));
       *
       *
       * // Example 3 - Give a static list of templates.
       * // The section template can also be chosen from a fixed list of templates.
       * // There for the drop down capability of the TppButtons can be used.
       * TPP_API.Decorate
       *      .element($section)
       *      .addButton(TPP_API.Button.CREATE_SIBLING_SECTION.options(
       *        [
       *          {id: 'section_template_uid_1', label : 'Basic Section'},
       *          {id: 'section_template_uid_2', label : 'Advanced Section'}
       *        ]
       *      ));
       *
       * // Example 4 - Position and section name
       * // The position relative to the given section can be set and the name of the section can also be set.
       * // (If there are collisions in the section names a suffix will be appended.)
       * // The object given to the context i
       *  TPP_API.Decorate
       *      .element($section)
       *      .addButton(TPP_API.Button.CREATE_SIBLING_SECTION.context(
       *        {
       *          template: "teaser_entry_template_uid"
       *          position: TPP_API.SectionPosition.AFTER,
       *          sectionName: "teaser_entry"
       *        }
       *      ));
       *
       * // Example 5 - Full example, decorate every child section with a button.
       * // This should be full example for a list of sibling sections
       *
       * // a) Assume you have given a list of section in your application.
       * // Every section is annotated with its own previewId.
       * <div data-slot="teaser">
       *   <div class="slot-entry" data-preview-id="..."/>
       *   <div class="slot-entry" data-preview-id="..."/>
       * </div>
       *
       * // b) Decorate each slot entry with a create sibling button.
       * var $slotEntries = document.querySelectorAll('.slot-entry');
       * [].forEach.call($slotEntries, ($section) => {
       *      Decorate.element($section).addButton(Decorate.CREATE_SIBLING_SECTION);
       * });
       *
       */
      CREATE_SIBLING_SECTION: ActionStore.CREATE_SIBLING_SECTION,

      /**
       * This button adds the ability to edit the element given by the previewId.
       * It supports Sections, Pages and PageRefs.
       * Usually there is no further configuration needed.
       * @public
       * @since 1.1.2
       * @name TPP_API.Button.EDIT_ELEMENT
       *
       */
      EDIT_ELEMENT: ActionStore.EDIT_ELEMENT,

      /**
       * This button adds the ability to edit the meta data of the element given by the previewId.
       * Usually there is no further configuration needed.
       * @public
       * @since NEXT_STABLE
       * @name TPP_API.Button.EDIT_META_DATA
       *
       */
      EDIT_META_DATA: ActionStore.EDIT_META_DATA,

      /**
       * This button adds the ability to delete the section given by a previewId.
       * Usually there is no further configuration needed.
       * @public
       * @since 1.1.2
       * @name TPP_API.Button.DELETE_SECTION
       *
       */
      DELETE_SECTION: ActionStore.DELETE_SECTION,

      /**
       * Dropdown button that shows all available workflow that could currently been started.
       * An element that is decorated with this button, should also be decorated with {@link TPP_API.Button.PROCESS_WORKFLOW}.
       * Either one of them will be shown, depending on the elements workflow state.
       * Usually there is no further configuration needed.
       * @public
       * @since 1.1.2
       * @name TPP_API.Button.START_WORKFLOW
       */
      START_WORKFLOW: ActionStore.START_WORKFLOW,

      /**
       * Dropdown button that triggers the translation dialog
       * @public
       * @since 1.2.4
       * @name TPP_API.Button.TRANSLATE
       */
      TRANSLATE: ActionStore.TRANSLATE,

      /**
       * Dropdown button that shows all available workflow steps that could currently been taken.
       * An element that is decorated with this button, should also be decorated with {@link TPP_API.Button.START_WORKFLOW}.
       * Either one of them will be shown, depending on the elements workflow state.
       * Usually there is no further configuration needed.
       * @public
       * @since 1.1.2
       * @name TPP_API.Button.PROCESS_WORKFLOW
       */
      PROCESS_WORKFLOW: ActionStore.PROCESS_WORKFLOW,


      /**
       * Open the crop image dialog for an image given as a previewId.
       * The resolution has to be given as additional context value or will be derived from
       * the decorated tab.
       * @public
       * @since 1.1.0
       * @name TPP_API.Button.CROP_IMAGE
       * @example
       * //
       * // Example 1 - decorate image tag, give previewId and resolution via data-fs-resolution
       * // The previewId for the image can be rendered like this
       * //
       * $CMS_VALUE(previewId:"fs_image")$
       *
       * // Assume you have the following image tag
       * <img src="..." alt="..." id="headerImage" data-preview-id="..." data-tpp-context-image-resolution="HEADER_640x150">
       * <img src="..." alt="..." id="headerImage" data-preview-id="..." data-tpp-context-image-resolutions="HEADER_640x150, HEADER_1280x300">
       *
       * // Decorate the image tag
       * var $image = document.getElementById('#headerImage');
       * TPP_API.Decorate.element($image).addButton(TPP_API.Button.CROP_IMAGE);
       *
       * //
       * // Example 2 - decorate image tag, give previewId and resolution via api.
       * //
       * // Assume you have the previewId and resolution fetched via the CaaS
       * var imageResolution = ...;
       * var previewId = ...;
       *
       * // Your image tag does not need the attributes now
       * <img src="..." alt="..." id="headerImage">
       *
       * // Decorate the image tag
       * var $image = document.getElementById('#headerImage');
       * var cropImageButton = TPP_API.Button.CROP_IMAGE.context({imageResolution: imageResolution});
       * TPP_API.Decorate.element($image, previewId).addButton(cropImageButton);
       *
       */
      CROP_IMAGE: ActionStore.CROP_IMAGE,

      /**
       * Adds bookmark for element.
       * @public
       * @since 1.1.6
       * @name TPP_API.Button.ADD_BOOKMARK
       */
      ADD_BOOKMARK: ActionStore.ADD_BOOKMARK,

      /**
       * Removes bookmark for element.
       * @public
       * @since 1.1.6
       * @name TPP_API.Button.DELETE_BOOKMARK
       */
      DELETE_BOOKMARK: ActionStore.DELETE_BOOKMARK,

      /**
       * This button prints debug information to the browser console.
       * It's only visible when debug logging is enabled.
       * {@link TPP_API.enableDebugLog}
       * Usually there is no further configuration needed.
       * @public
       * @since 1.1.2
       * @name TPP_API.Button.DEBUG_STATUS
       **/
      DEBUG_STATUS: ActionStore.DEBUG_STATUS
    };

  }

  function checkForReceiver(util, common, timeout) {

    var inIFrame = function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };
    util.messageService.updateReceiverOverride();
    return new Promise(function (resolve) {
      if (typeof window !== 'undefined' && inIFrame()) {
        util.log("This app runs in iframe and uses First Spirit TPP so we assume it is in edit mode. Try to connect with TPP-Api.");
        var pingResult = null;
        common.ping(function (result) {
          pingResult = result;
          if (result.version !== FRONTEND_VERSION) {
            util.log("WARNING: TPP-Module and TPP_API Version missmatch. " +
                       "TPP_API version: " + FRONTEND_VERSION + " TPP-Module Version: " + result.version);
          }
        });

        setTimeout(function () {
          if (!pingResult) {
            util.log("WARNING: Could not reach TPP-Module receiver (TIMEOUT=" + timeout + "ms). The Module might not be installed or this app runs within an iframe but not in FirstSpirits ContentCreators.");
            resolve(false);
          } else {
            util.log("SUCCESS: Connection to TPP-Module could be established. " +
                       "TPP_API version: " + FRONTEND_VERSION + " TPP-Module Version: " + pingResult.version);
            resolve(true);
          }
        }, timeout)

      } else {
        resolve(false);
      }
    });
  }

  function connectHandler(receiverFound, util, config) {
    return new Promise(function (resolve) {
      if (receiverFound) {
        util.messageService.connectApi(config.origin, function () {
          util.log("Message handler initialized");
          resolve(receiverFound);
        });
      } else {
        resolve(receiverFound);
      }
    });
  }


  /**
   * Added for better testability.
   * Access to the three API-Parts as Constructor.
   * Each of the three parts should not depend on global variables.
   * The TPP_API, util, and config can be given as constructor argument.
   * The iframe communication can be mocked be setting another message receiver,
   * but DOM-Event will be emitted and received (can be partially mocked by changing util.emit);
   * @private
   */
  TPP_API._internal = {
    CommonConstructor: Common,
    OperationConstructor: Operation,
    DecorateConstructor: Decorate,
    DebugConstructor: Debug,
    util: util,
    setMessageReceiver: function (receiver) {
      messageReceiverOverride = receiver;
      util.messageService.updateReceiverOverride();
    }
  };


  /**
   * Enables the debug log. Setting is stored in localStorage and survives reload.
   * @name TPP_API.enableDebugLog
   * @public
   * @since 1.0.0
   * @param {boolean} [enable=true]
   */
  TPP_API.enableDebugLog = function (enable) {
    enable = typeof (enable) === 'undefined' || enable;
    util.log.setEnabled(enable);
  };


  var initCalled = false;
  /**
   * The API has to be initialize either by calling TPP_API.init() or by adding a blank data-tpp-init attribute to the the script tag. You should use only one of these methods once.
   * @name TPP_API.init
   * @public
   * @since 1.0.0
   * @example
   * // Default values
   * TPP_API.init({
   *     origin: "*",                                       // every origin allowed
   *
   *     autoScanDelay: null                                // disabled
   *                                                        // This option is deprecated and might be replaced with a observer based solution)
   *
   *     alwaysDebug: false,                                // if true, debug will be enabled by default.
   *                                                        // Otherwise debug has to be toggled manually
   *
   *     autoReload: false,                                 // disabled
   *
   *     deletePageWorkflow: null,                          // disabled, overrides the default delete workflow configured in project
   *
   *     workflowMode: TPP_API.WorkflowMode.PAGE_DRIVEN,    // Workflows will be started on PageRef.
   *                                                        // This is TPPs initial approach
   *   }
   *
   * // Reasonable alternative configuration
   * TPP_API.init({
   *     origin: "https://dev.contentCreatorUrl.com:9000",    // The domain of the outer ContentCreator window.
   *                                                          // Restricts communication only to out frame with this domain.
   *
   *     autoScanDelay: 1000                                  // Scan every 1000ms
   *                                                          // This option is deprecated and might be replaced
   *                                                          // with a observer based solution.
   *
   *     alwaysDebug: true,                                   // Debug logging and PP_API.Button.DEBUG_STATUS action is enabled.
   *
   *     autoReload: true,                                    // Reloads the whole page on certain actions
   *
   *     deletePageWorkflow: null,                            // Disabled, overrides the default delete workflow configured in project
   *
   *     workflowMode: TPP_API.WorkflowMode.PAGE_REF_DRIVEN,  // Workflows will be started on PageRefs.
   *                                                          // This is the approach more compatible with the actions
   *                                                          // accessible the ContentCreator frame.
   *
   *   }
   * );
   *
   * @example
   * // Alternatively use data-tpp-* attributes
   *
   * <script src="$PATH_TO_MODULE$/lib/fs-tpp-api.js"
   *   data-tpp-init
   *   data-tpp-auto-reload="true"></script>
   *
   * // Note, that data-tpp-init has to be always present in the second method, that there is a data-tpp-* prefix and that the camelCase on one side is kebab-case on the other side.
   *
   *
   * @param {Object} tppConfig
   */
  TPP_API.init = function (tppConfig) {
    if (initCalled) {
      console.error('TPP_API.init() was called twice. Please do only one of EITHER calling it directly OR using <script data-tpp-init>');
    }
    initCalled = true;

    config = Object.assign({}, DEFAULT_CONFIG, tppConfig);

    TPP_API.Common = new Common(TPP_API, util, config);
    TPP_API.Operation = new Operation(TPP_API, util, config);
    TPP_API.Decorate = new Decorate(TPP_API, util, config);
    TPP_API.Debug = new Debug(TPP_API, util, config);

    initButtonConstants(TPP_API);


    if (config.autoScanDelay) {
      setTimeout(TPP_API.Decorate.scan, parseInt(config.autoScanDelay, 10));
    }

    if (config.alwaysDebug) {
      util.log.setEnabled(true);
    }

    if (config.autoReload) {
      var reloadEvents = [TPP_API.Event.CONTENT_CHANGED, TPP_API.Event.ELEMENT_DELETED];
      reloadEvents.forEach(function (eventName) {
        document.body.addEventListener(eventName, self.location.reload.bind(self.location));
      });
    }

    // deprecated - was used in old prototypes
    TPP_API.Decorate.Action = TPP_API.Button;
    TPP_API.Decorate.Icon = TPP_API.Icon;

    //Connect with receiver
    var timeout = 800;
    checkForReceiver(util, TPP_API.Common, timeout)
      .then(function (receiverFound) {
        return connectHandler(receiverFound, util, config);
      })
      .then(function () {
        TPP_API.Debug.apiInitialized = true;
      });
  };


  (/**
   * @private
   * Script tag initialize
   * @param {HTMLElement} $script
   * param {{tppOrigin,tppAlwaysDebug,tppAutoScanDelay,tppAutoReload}} data
   */
  function ($script) {
    if ($script) {

      var data = $script.dataset;
      var config = {};

      var getTppCamelCase = function (str) {
        return "tpp" + str[0].toUpperCase() + str.slice(1);
      };

      var setBoolean = function (config, key, data) {
        var strValue = data[getTppCamelCase(key)];
        if (typeof (strValue) !== 'undefined') {
          config[key] = (strValue === 'true');
        }
      };

      var setNumber = function (config, key, data) {
        var strValue = data[getTppCamelCase(key)];
        var value = Number.parseInt(strValue);
        if (!Number.isNaN(value)) {
          config[key] = value;
        }
      };

      var setString = function (config, key, data) {
        var strValue = data[getTppCamelCase(key)];
        if (typeof (strValue) !== 'undefined') {
          config[key] = strValue;
        }
      };

      setString(config, 'origin', data);

      setString(config, 'workflowMode', data);

      setBoolean(config, 'alwaysDebug', data);

      setNumber(config, 'autoScanDelay', data);

      setBoolean(config, 'autoReload', data);

      setBoolean(config, 'deleteSectionEnabled', data);

      setString(config, 'deletePageWorkflow', data);

      TPP_API.init(config);
    }
  })(typeof (document) !== 'undefined' && document.querySelector('script[data-tpp-init]'));

  /**
   * In setups where you can not control the load order of your scripts you can define this as a global callback.
   * It will be called with TPP_API as parameter.
   * The best way would be to avoid such situations and control the load order of your scripts.
   * @private
   * @name window.TPP_API_LOADED
   *
   * @example
   * window.TPP_API_LOADED=function(TPP_API){
   *   // You can use the TPP_API now.
   *   // You should initialize and configure it as the first step
   * }
   */
  if (typeof (window) !== 'undefined' && typeof window['TPP_API_LOADED'] === 'function') { // async / deferred usage
    window['TPP_API_LOADED'](TPP_API);
  }

  util.log("TPP_API loaded.");
  if (typeof window === 'undefined') {
    util.log("The API is not supposed to run on server side. It adds event listeners to the global window object.");
  }

  return TPP_API;
}))
;
